import { ROUTES_NAMES } from 'constants/servicenow.routes'
import { Mock } from 'types/global'

export const MocksVariablesServiceNow:Mock[] = [ 
    { 
        'url': ROUTES_NAMES.variables.get.all, 
        'method': 'GET', 
        'data': {
            "result": [
              {
                "active": true,
                "label": "Notifica user",
                "dynamic_value_field": "",
                "type": 6,
                "mandatory": false,
                "displayvalue": "",
                "friendly_type": "single_line_text",
                "display_type": "Texto de Linha Única",
                "render_label": true,
                "read_only": false,
                "name": "u_notifica_user",
                "attributes": "edge_encryption_enabled=true",
                "id": "84bead3fdbd87110839481640496196c",
                "value": "",
                "dynamic_value_dot_walk_path": "",
                "help_text": "",
                "max_length": 0,
                "order": -1
              },
              {
                "active": true,
                "label": "Tipo de Notificação",
                "dynamic_value_field": "",
                "type": 5,
                "mandatory": true,
                "displayvalue": "",
                "friendly_type": "select_box",
                "display_type": "Selecionar Caixa",
                "render_label": true,
                "read_only": false,
                "name": "notification_type",
                "attributes": "edge_encryption_enabled=true",
                "id": "4a902e791b1da11060d9426fe54bcbc7",
                "choices": [
                  {
                    "index": 0,
                    "label": "-- Nenhum --",
                    "value": ""
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 1,
                    "recurring_price": 0,
                    "label": "Anônimo",
                    "value": "anonymous",
                    "price_currency": "BRL"
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 2,
                    "recurring_price": 0,
                    "label": "Identificado",
                    "value": "identified",
                    "price_currency": "BRL"
                  }
                ],
                "value": "",
                "dynamic_value_dot_walk_path": "",
                "help_text": "",
                "max_length": 0,
                "order": 200
              },
              {
                "active": true,
                "label": "Nome do notificante",
                "dynamic_value_field": "",
                "type": 6,
                "mandatory": false,
                "displayvalue": "",
                "friendly_type": "single_line_text",
                "display_type": "Texto de Linha Única",
                "render_label": true,
                "read_only": false,
                "name": "reporter_name",
                "attributes": "edge_encryption_enabled=true",
                "id": "0d616ab91b1da11060d9426fe54bcb2e",
                "value": "",
                "dynamic_value_dot_walk_path": "",
                "help_text": "",
                "max_length": 0,
                "order": 400
              },
              {
                "active": true,
                "label": "formatter",
                "dynamic_value_field": "",
                "type": 12,
                "mandatory": false,
                "displayvalue": "",
                "friendly_type": "break",
                "display_type": "Interrupção",
                "render_label": false,
                "read_only": false,
                "name": "formatter11",
                "attributes": "edge_encryption_enabled=true",
                "id": "d3a5b23f1b95251060d9426fe54bcb69",
                "value": "",
                "dynamic_value_dot_walk_path": "",
                "help_text": "",
                "max_length": 0,
                "order": 600
              },
              {
                "active": true,
                "label": "Data da ocorrência",
                "dynamic_value_field": "",
                "type": 9,
                "mandatory": true,
                "displayvalue": "",
                "friendly_type": "date",
                "display_type": "Data",
                "render_label": true,
                "read_only": false,
                "name": "date_incident",
                "attributes": "edge_encryption_enabled=true",
                "id": "dbb422bd1b1da11060d9426fe54bcb54",
                "value": "",
                "dynamic_value_dot_walk_path": "",
                "t_value": "",
                "help_text": "",
                "max_length": 0,
                "order": 800
              },
              {
                "active": true,
                "label": "Unidade da notificação",
                "dynamic_value_field": "",
                "type": 8,
                "mandatory": true,
                "displayvalue": "",
                "friendly_type": "reference",
                "display_type": "Referência",
                "reference": "cmn_location",
                "render_label": true,
                "ref_qualifier": "cmn_location_type=hospital/clinic/medical center^EQ",
                "read_only": false,
                "name": "location_incident",
                "attributes": "edge_encryption_enabled=true",
                "id": "2e4462f91b1da11060d9426fe54bcb76",
                "value": "",
                "dynamic_value_dot_walk_path": "",
                "help_text": "",
                "max_length": 0,
                "order": 900
              },
              {
                "active": true,
                "label": "Turno da ocorrência",
                "dynamic_value_field": "",
                "type": 5,
                "mandatory": true,
                "displayvalue": "",
                "friendly_type": "select_box",
                "display_type": "Selecionar Caixa",
                "render_label": true,
                "read_only": false,
                "name": "shift_incident",
                "attributes": "edge_encryption_enabled=true",
                "id": "2516eebd1b1da11060d9426fe54bcb32",
                "choices": [
                  {
                    "index": 0,
                    "label": "-- Nenhum --",
                    "value": ""
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 1,
                    "recurring_price": 0,
                    "label": "Diurno (7h - 18h59)",
                    "value": "daytime",
                    "price_currency": "BRL"
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 2,
                    "recurring_price": 0,
                    "label": "Noturno  (19h - 6h59)",
                    "value": "nighttime",
                    "price_currency": "BRL"
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 3,
                    "recurring_price": 0,
                    "label": "Não sei informar",
                    "value": "not_known",
                    "price_currency": "BRL"
                  }
                ],
                "value": "",
                "dynamic_value_dot_walk_path": "",
                "help_text": "",
                "max_length": 0,
                "order": 1000
              },
              {
                "active": true,
                "label": "Setor notificante",
                "dynamic_value_field": "",
                "type": 8,
                "mandatory": true,
                "displayvalue": "",
                "friendly_type": "reference",
                "display_type": "Referência",
                "reference": "x_rdsls_notificabe_sectors",
                "render_label": true,
                "ref_qualifier": "u_active=true^EQ",
                "read_only": false,
                "name": "reporter_sector",
                "attributes": "edge_encryption_enabled=true",
                "id": "d828e2711b5da11060d9426fe54bcbe7",
                "value": "",
                "dynamic_value_dot_walk_path": "",
                "help_text": "",
                "max_length": 0,
                "order": 1100
              },
              {
                "active": true,
                "label": "Setor notificado",
                "dynamic_value_field": "",
                "type": 8,
                "mandatory": true,
                "displayvalue": "",
                "friendly_type": "reference",
                "display_type": "Referência",
                "reference": "x_rdsls_notificabe_sectors",
                "render_label": true,
                "ref_qualifier": "u_active=true^EQ",
                "read_only": false,
                "name": "incident_sector",
                "attributes": "edge_encryption_enabled=true",
                "id": "f758e6711b5da11060d9426fe54bcb95",
                "value": "",
                "dynamic_value_dot_walk_path": "",
                "help_text": "",
                "max_length": 0,
                "order": 1200
              },
              {
                "active": true,
                "label": "formatter",
                "dynamic_value_field": "",
                "type": 12,
                "mandatory": false,
                "displayvalue": "",
                "friendly_type": "break",
                "display_type": "Interrupção",
                "render_label": false,
                "read_only": false,
                "name": "formatter12",
                "attributes": "edge_encryption_enabled=true",
                "id": "0eb53efb1b95251060d9426fe54bcb4e",
                "value": "",
                "dynamic_value_dot_walk_path": "",
                "help_text": "",
                "max_length": 0,
                "order": 1500
              },
              {
                "active": true,
                "label": "Tipo do incidente:",
                "dynamic_value_field": "",
                "type": 5,
                "mandatory": true,
                "displayvalue": "",
                "friendly_type": "select_box",
                "display_type": "Selecionar Caixa",
                "render_label": true,
                "read_only": false,
                "name": "incident_type",
                "attributes": "edge_encryption_enabled=true",
                "id": "d8fbea751b5da11060d9426fe54bcb18",
                "choices": [
                  {
                    "index": 0,
                    "label": "-- Nenhum --",
                    "value": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 1,
                    "recurring_price": 0,
                    "label": "Abertura involuntária da ferida operatória (deiscência)",
                    "value": "abertura_involuntaria_da_ferida_operatoria_deiscencia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 2,
                    "recurring_price": 0,
                    "label": "Agressão física",
                    "value": "agressao_fisica",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 3,
                    "recurring_price": 0,
                    "label": "Agressão sexual",
                    "value": "agressao_sexual",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 4,
                    "recurring_price": 0,
                    "label": "Alocação incorreta de paciente",
                    "value": "alocacao_incorreta_de_paciente",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 5,
                    "recurring_price": 0,
                    "label": "Ameaça a respiração (sufocamento e confinamento)",
                    "value": "ameaca_a_respiracao_sufocamento_e_confinamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 6,
                    "recurring_price": 0,
                    "label": "Ameaça de morte",
                    "value": "ameaca_de_morte",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 7,
                    "recurring_price": 0,
                    "label": "Atraso de entrega de refeição pelo restaurante",
                    "value": "atraso_de_entrega_de_refeicao_pelo_restaurante",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 8,
                    "recurring_price": 0,
                    "label": "Atraso do procedimento cirúrgico",
                    "value": "atraso_do_procedimento_cirurgico",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 9,
                    "recurring_price": 0,
                    "label": "Atraso/falha na entrega de insumos pelo restaurante",
                    "value": "atraso_falha_na_entrega_de_insumos_pelo_restaurante",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 10,
                    "recurring_price": 0,
                    "label": "Atraso/falha na retirada de bandeja/utensílios do box/quarto",
                    "value": "atraso_falha_na_retirada_de_bandeja_utensilios_do_box_quarto",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 11,
                    "recurring_price": 0,
                    "label": "Atraso/falha no abastecimento do arsenal/almoxarifado",
                    "value": "atraso_falha_no_abastecimento_do_arsenal_almoxarifado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 12,
                    "recurring_price": 0,
                    "label": "Atraso na coleta de exames",
                    "value": "atraso_na_coleta_de_exames",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 13,
                    "recurring_price": 0,
                    "label": "Atraso na entrega da dieta",
                    "value": "atraso_na_entrega_da_dieta",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 14,
                    "recurring_price": 0,
                    "label": "Atraso na entrega de exames",
                    "value": "atraso_na_entrega_de_exames",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 15,
                    "recurring_price": 0,
                    "label": "Atraso na entrega medicamento",
                    "value": "atraso_na_entrega_medicamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 16,
                    "recurring_price": 0,
                    "label": "Atraso na entrega/reposição de uniformes",
                    "value": "atraso_na_entrega_reposicao_de_uniformes",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 17,
                    "recurring_price": 0,
                    "label": "Atraso na infusão de hemocomponentes",
                    "value": "atraso_na_infusão_de_hemocomponentes",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 18,
                    "recurring_price": 0,
                    "label": "Atraso na internação dos pacientes",
                    "value": "atraso_na_internacao_dos_pacientes",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 19,
                    "recurring_price": 0,
                    "label": "Atraso na liberação de laudos/resultados",
                    "value": "atraso_na_liberacao_de_laudos_resultados",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 20,
                    "recurring_price": 0,
                    "label": "Atraso na limpeza do leito/quarto/sala cirúrgica",
                    "value": "atraso_na_limpeza_do_leito_quarto_sala_cirurgica",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 21,
                    "recurring_price": 0,
                    "label": "Atraso na realização/coleta de exames",
                    "value": "atraso_na_realizacao_coleta_de_exames",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 22,
                    "recurring_price": 0,
                    "label": "Atraso na realização de exames",
                    "value": "atraso_na_realizacao_de_exames",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 23,
                    "recurring_price": 0,
                    "label": "Atraso na reposição de material ou medicamento",
                    "value": "atraso_na_reposicao_de_material_ou_medicamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 24,
                    "recurring_price": 0,
                    "label": "Atraso na reposição do enxoval",
                    "value": "atraso_na_reposicao_do_enxoval",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 25,
                    "recurring_price": 0,
                    "label": "Atraso no atendimento da manutenção",
                    "value": "atraso_no_atendimento_da_manutencao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 26,
                    "recurring_price": 0,
                    "label": "Ausência/dano na pulseira de identificação",
                    "value": "ausencia_dano_na_pulseira_de_identificacao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 27,
                    "recurring_price": 0,
                    "label": "Ausência de código de barra/rastreabilidade",
                    "value": "ausencia_de_codigo_de_barra_rastreabilidade",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 28,
                    "recurring_price": 0,
                    "label": "Ausência de pulseira de queda",
                    "value": "ausencia_de_pulseira_de_queda",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 29,
                    "recurring_price": 0,
                    "label": "Ausência de rastreabilidade",
                    "value": "ausencia_de_rastreabilidade",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 30,
                    "recurring_price": 0,
                    "label": "Ausência/falha na devolução do material/medicamento",
                    "value": "ausencia_falha_na_devolucao_do_material_medicamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 31,
                    "recurring_price": 0,
                    "label": "Ausência/falha na extensão do dispositivo (ausência de polifix, equipo ou torneira se necessário)",
                    "value": "ausencia_falha_na_extensao_do_dispositivo_ausencia_de_polifix_equipo_ou_torneira_se_necessario",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 32,
                    "recurring_price": 0,
                    "label": "Ausência/falha no preenchimento dos documentos",
                    "value": "ausencia_falha_no_preenchimento_dos_documentos",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 33,
                    "recurring_price": 0,
                    "label": "Broncoaspiração",
                    "value": "broncoaspiracao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 34,
                    "recurring_price": 0,
                    "label": "Cadastro errado de médico assistente (CRM, especialidade, nome)",
                    "value": "cadastro_errado_de_medico_assistente_crm_especialidade_nome",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 35,
                    "recurring_price": 0,
                    "label": "Cadastro errado de paciente",
                    "value": "cadastro_errado_de_paciente",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 36,
                    "recurring_price": 0,
                    "label": "Cadastro errado do convenio",
                    "value": "cadastro_errado_do_convenio",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 37,
                    "recurring_price": 0,
                    "label": "Cancelamento de exames",
                    "value": "cancelamento_de_exames",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 38,
                    "recurring_price": 0,
                    "label": "Cancelamento de procedimento cirúrgico",
                    "value": "cancelamento_de_procedimento_cirurgico",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 39,
                    "recurring_price": 0,
                    "label": "Cânula de traqueostomia",
                    "value": "canula_de_traqueostomia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 40,
                    "recurring_price": 0,
                    "label": "Cânula endotraqueal",
                    "value": "canula_endotraqueal",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 41,
                    "recurring_price": 0,
                    "label": "Cateter arterial",
                    "value": "cateter_arterial",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 42,
                    "recurring_price": 0,
                    "label": "Cateter central de inserção periférica (picc)",
                    "value": "cateter_central_de_insercao_periferica_picc",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 43,
                    "recurring_price": 0,
                    "label": "Cateter de monitorização intracraniana (pic)",
                    "value": "cateter_de_monitorizacao_intracraniana_pic",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 44,
                    "recurring_price": 0,
                    "label": "Cateter nasoentérico",
                    "value": "cateter_nasoenterico",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 45,
                    "recurring_price": 0,
                    "label": "Cateter nasogástrico",
                    "value": "cateter_nasogastrico",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 46,
                    "recurring_price": 0,
                    "label": "Cateter tenckhoff",
                    "value": "cateter_tenckhoff",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 47,
                    "recurring_price": 0,
                    "label": "Cateter venoso central",
                    "value": "cateter_venoso_central",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 48,
                    "recurring_price": 0,
                    "label": "Cateter venoso periférico",
                    "value": "cateter_venoso_periferico",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 49,
                    "recurring_price": 0,
                    "label": "Cateter vesical de demora",
                    "value": "cateter_vesical_de_demora",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 50,
                    "recurring_price": 0,
                    "label": "Cilindro danificado",
                    "value": "cilindro_danificado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 51,
                    "recurring_price": 0,
                    "label": "Cirurgia em membro ou local errado",
                    "value": "cirurgia_em_membro_ou_local_errado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 52,
                    "recurring_price": 0,
                    "label": "Cirurgia em órgão errado",
                    "value": "cirurgia_em_orgao_errado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 53,
                    "recurring_price": 0,
                    "label": "Cirurgia em paciente errado",
                    "value": "cirurgia_em_paciente_errado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 54,
                    "recurring_price": 0,
                    "label": "Cirurgia Suspensa",
                    "value": "cirurgia_suspensa",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 55,
                    "recurring_price": 0,
                    "label": "Cobrança indevida do medicamento",
                    "value": "cobranca_indevida_do_medicamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 56,
                    "recurring_price": 0,
                    "label": "Colonostomia",
                    "value": "colonostomia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 57,
                    "recurring_price": 0,
                    "label": "Comportamento inadequado",
                    "value": "comportamento_inadequado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 58,
                    "recurring_price": 0,
                    "label": "Dai (dermatite associada a incontinência)",
                    "value": "dai_dermatite_associada_a_incontinencia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 59,
                    "recurring_price": 0,
                    "label": "Dano infligido a si próprio/suicídio",
                    "value": "dano_infligido_a_si_proprio_suicidio",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 60,
                    "recurring_price": 0,
                    "label": "Danos contra bens",
                    "value": "danos_contra_bens",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 61,
                    "recurring_price": 0,
                    "label": "Dermatite",
                    "value": "dermatite",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 62,
                    "recurring_price": 0,
                    "label": "Descarte de perfurocortantes em recipiente inadequado (saco, lixeiras, outros)",
                    "value": "descarte_de_perfurocortantes_em_recipiente_inadequado_saco_lixeiras_outros",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 63,
                    "recurring_price": 0,
                    "label": "Descarte inadequado de enxoval/uniformes",
                    "value": "descarte_inadequado_de_enxoval_uniformes",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 64,
                    "recurring_price": 0,
                    "label": "Descumprimento da nr32",
                    "value": "descumprimento_da_nr32",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 65,
                    "recurring_price": 0,
                    "label": "Desvio de qualidade de produtos",
                    "value": "desvio_de_qualidade_de_produtos",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 66,
                    "recurring_price": 0,
                    "label": "Desvio de qualidade do medicamento",
                    "value": "desvio_de_qualidade_do_medicamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 67,
                    "recurring_price": 0,
                    "label": "Desvio de qualidade no alimento/dieta",
                    "value": "desvio_de_qualidade_no_alimento_dieta",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 68,
                    "recurring_price": 0,
                    "label": "Desvio de qualidade no envio do anatomopatológico",
                    "value": "desvio_de_qualidade_no_envio_do_anatomopatologico",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 69,
                    "recurring_price": 0,
                    "label": "Dieta errada",
                    "value": "dieta_errada",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 70,
                    "recurring_price": 0,
                    "label": "Dieta oral com consistência inadequada",
                    "value": "dieta_oral_com_consistencia_inadequada",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 71,
                    "recurring_price": 0,
                    "label": "Dreno",
                    "value": "dreno",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 72,
                    "recurring_price": 0,
                    "label": "Embolia Pulmonar",
                    "value": "embolia_pulmonar",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 73,
                    "recurring_price": 0,
                    "label": "Envio duplicado de medicamento",
                    "value": "envio_duplicado_de_medicamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 74,
                    "recurring_price": 0,
                    "label": "Enxoval danificado",
                    "value": "enxoval_danificado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 75,
                    "recurring_price": 0,
                    "label": "Equipamento/infraestrutura danificado",
                    "value": "equipamento_infraestrutura_danificado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 76,
                    "recurring_price": 0,
                    "label": "Equipamento/infraestrutura deteriorado",
                    "value": "equipamento_infraestrutura_deteriorado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 77,
                    "recurring_price": 0,
                    "label": "Equipamento/infraestrutura inadequado",
                    "value": "equipamento_infraestrutura_inadequado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 78,
                    "recurring_price": 0,
                    "label": "Equipamento/infraestrutura inexistente",
                    "value": "equipamento_infraestrutura_inexistente",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 79,
                    "recurring_price": 0,
                    "label": "Erro de prescrição",
                    "value": "erro_de_prescricao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 80,
                    "recurring_price": 0,
                    "label": "Evasão do paciente",
                    "value": "evasao_do_paciente",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 81,
                    "recurring_price": 0,
                    "label": "Evasão do paciente (do leito ou do hospital)",
                    "value": "evasao_do_paciente_do leito_ou_do_hospital",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 82,
                    "recurring_price": 0,
                    "label": "Evento relacionado a procedimento médico/complicações potenciais do procedimento",
                    "value": "evento_relacionado_a_procedimento_medico_complicacoes_potenciais_do_procedimento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 83,
                    "recurring_price": 0,
                    "label": "Exposição a substância (envenenamento ou corrosão)",
                    "value": "exposicao_a_substancia_envenenamento_ou_corrosao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 84,
                    "recurring_price": 0,
                    "label": "Exposição repetida de órgãos pela ferida operatória após a cirurgia (evisceração)",
                    "value": "exposicao_repetida_de_orgaos_pela_ferida_operatoria_apos_a_cirurgia_evisceracao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 85,
                    "recurring_price": 0,
                    "label": "Extravasamento (contraste/quimio ou medicamentos)",
                    "value": "extravasamento_contraste_quimio_ou_medicamentos",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 86,
                    "recurring_price": 0,
                    "label": "Extravasamento pelo óstio (cateter ou gastrostomia)",
                    "value": "extravasamento_pelo_ostio_cateter_ou_gastrostomia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 87,
                    "recurring_price": 0,
                    "label": "Extravio/ausência de documento",
                    "value": "extravio_ausencia_de_documento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 88,
                    "recurring_price": 0,
                    "label": "Extubação acidental",
                    "value": "extubacao_acidental",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 89,
                    "recurring_price": 0,
                    "label": "Extubação endotraqueal acidental",
                    "value": "extubacao_endotraqueal_acidental",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 90,
                    "recurring_price": 0,
                    "label": "Falha/atraso na entrega de insumos",
                    "value": "falha_atraso_na_entrega_de_insumos",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 91,
                    "recurring_price": 0,
                    "label": "Falha/atraso na liberação do paciente do centro cirúrgico",
                    "value": "falha_atraso_na_liberacao_do_paciente_do_centro_cirurgico",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 92,
                    "recurring_price": 0,
                    "label": "Falha/ausência da identificação da alergia",
                    "value": "falha_ausencia_da_identificacao_da_alergia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 93,
                    "recurring_price": 0,
                    "label": "Falha/ausência de comunicação entre os setores",
                    "value": "falha_ausencia_de_comunicacao_entre_os_setores",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 94,
                    "recurring_price": 0,
                    "label": "Falha/ausência de comunicação na passagem do caso do paciente",
                    "value": "falha_ausencia_de_comunicacao_na_passagem_do_caso_do_paciente",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 95,
                    "recurring_price": 0,
                    "label": "Falha/ausência na comunicação de laudos/resultados críticos",
                    "value": "falha_ausencia_na_comunicacao_de_laudos_resultados_criticos",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 96,
                    "recurring_price": 0,
                    "label": "Falha/ausência no uso do epi",
                    "value": "falha_ausencia_no_uso_do_epi",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 97,
                    "recurring_price": 0,
                    "label": "Falha de equipamento",
                    "value": "falha_de_equipamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 98,
                    "recurring_price": 0,
                    "label": "Falha do atendimento no guarda-volumes",
                    "value": "falha_do_atendimento_no_guarda_volumes",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 99,
                    "recurring_price": 0,
                    "label": "Falha durante a assistência à saúde",
                    "value": "falha_durante_a_assistencia_a_saude",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 100,
                    "recurring_price": 0,
                    "label": "Falha durante o procedimento cirúrgico",
                    "value": "falha_durante_o_procedimento_cirurgico",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 101,
                    "recurring_price": 0,
                    "label": "Falha em equipamentos médico-hospitalares em uso",
                    "value": "falha_em_equipamentos_medico_hospitalares_em_uso",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 102,
                    "recurring_price": 0,
                    "label": "Falha envolvendo cateter venoso",
                    "value": "falha_envolvendo_cateter_venoso",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 103,
                    "recurring_price": 0,
                    "label": "Falha envolvendo dietas",
                    "value": "falha_envolvendo_dietas",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 104,
                    "recurring_price": 0,
                    "label": "Falha envolvendo sondas",
                    "value": "falha_envolvendo_sondas",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 105,
                    "recurring_price": 0,
                    "label": "Falha na abertura da gaveta ou no cartucho",
                    "value": "falha_na_abertura_da_gaveta_ou_no_cartucho",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 106,
                    "recurring_price": 0,
                    "label": "Falha na abertura de documentos",
                    "value": "falha_na_abertura_de_documentos",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 107,
                    "recurring_price": 0,
                    "label": "Falha na adesão aos bundles/pacote de medidas de prevenção",
                    "value": "falha_na_adesao_aos_bundles_pacote_de_medidas_de_prevencao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 108,
                    "recurring_price": 0,
                    "label": "Falha na administração da dieta/suplementos",
                    "value": "falha_na_administracao_da_dieta_suplementos",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 109,
                    "recurring_price": 0,
                    "label": "Falha na administração de gases",
                    "value": "falha_na_administracao_de_gases",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 110,
                    "recurring_price": 0,
                    "label": "Falha na administração de O2 ou gases medicinais",
                    "value": "falha_na_administracao_de_o2_ou_gases_medicinais",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 111,
                    "recurring_price": 0,
                    "label": "Falha na administração do medicamento",
                    "value": "falha_na_administracao_do_medicamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 112,
                    "recurring_price": 0,
                    "label": "Falha na admissão do paciente no leito",
                    "value": "falha_na_admissao_do_paciente_no_leito",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 113,
                    "recurring_price": 0,
                    "label": "Falha na assistência radiológica",
                    "value": "falha_na_assistencia_radiologica",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 114,
                    "recurring_price": 0,
                    "label": "Falha na cadeia medicamentosa",
                    "value": "falha_na_cadeia_medicamentosa",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 115,
                    "recurring_price": 0,
                    "label": "Falha na campainha (chamada de enfermagem)",
                    "value": "falha_na_campainha_chamada_de_enfermagem",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 116,
                    "recurring_price": 0,
                    "label": "Falha na checagem",
                    "value": "falha_na_checagem",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 117,
                    "recurring_price": 0,
                    "label": "Falha na checagem da dieta/suplemento",
                    "value": "falha_na_checagem_da_dieta_suplemento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 118,
                    "recurring_price": 0,
                    "label": "Falha na codificação de cores",
                    "value": "falha_na_codificacao_de_cores",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 119,
                    "recurring_price": 0,
                    "label": "Falha na coleta dos exames ou nas amostras",
                    "value": "falha_na_coleta_dos_exames_ou_nas_amostras",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 120,
                    "recurring_price": 0,
                    "label": "Falha na comunicação da realização de exames (preparo, cancelamento, realização, outros)",
                    "value": "falha_na_comunicacao_da_realizacao_de_exames_preparo_cancelamento_realizacao_outros",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 121,
                    "recurring_price": 0,
                    "label": "Falha na comunicação na realização do transporte",
                    "value": "falha_na_comunicacao_na_realizacao_do_transporte",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 122,
                    "recurring_price": 0,
                    "label": "Falha na contenção física ou mecânica",
                    "value": "falha_na_contencao_fisica_ou_mecanica",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 123,
                    "recurring_price": 0,
                    "label": "Falha na detecção da deterioração clínica",
                    "value": "falha_na_deteccao_da_deterioracao_clinica",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 124,
                    "recurring_price": 0,
                    "label": "Falha na devolução do material",
                    "value": "falha_na_devolucao_do_material",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 125,
                    "recurring_price": 0,
                    "label": "Falha na digitalização do documento",
                    "value": "falha_na_digitalizacao_do_documento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 126,
                    "recurring_price": 0,
                    "label": "Falha na dispensação",
                    "value": "falha_na_dispensacao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 127,
                    "recurring_price": 0,
                    "label": "Falha na dispensação da dieta/suplementos (envio duplo de dieta, suplementos, outros)",
                    "value": "falha_na_dispensacao_da_dieta_suplementos_envio_duplo_de_dieta_suplementos_outros",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 128,
                    "recurring_price": 0,
                    "label": "Falha na dispensação do material ou medicamento",
                    "value": "falha_na_dispensacao_do_material_ou_medicamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 129,
                    "recurring_price": 0,
                    "label": "Falha na documentação",
                    "value": "falha_na_documentacao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 130,
                    "recurring_price": 0,
                    "label": "Falha na entrega do medicamento",
                    "value": "falha_na_entrega_do_medicamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 131,
                    "recurring_price": 0,
                    "label": "Falha na estabilização e/ou fixação do curativo",
                    "value": "falha_na_estabilizacao_e_ou_fixacao_do_curativo",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 132,
                    "recurring_price": 0,
                    "label": "Falha na higienização das mãos",
                    "value": "falha_na_higienizacao_das_maos",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 133,
                    "recurring_price": 0,
                    "label": "Falha na identificação da dieta",
                    "value": "falha_na_identificacao_da_dieta",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 134,
                    "recurring_price": 0,
                    "label": "Falha na identificação do paciente",
                    "value": "falha_na_identificacao_do_paciente",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 135,
                    "recurring_price": 0,
                    "label": "Falha na identificação do profissional no documento",
                    "value": "falha_na_identificacao_do_profissional_no_documento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 136,
                    "recurring_price": 0,
                    "label": "Falha na identificação do risco nutricional",
                    "value": "falha_na_identificacao_do_risco_nutricional",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 137,
                    "recurring_price": 0,
                    "label": "Falha na integração dos sistemas",
                    "value": "falha_na_integração_dos_sistemas",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 138,
                    "recurring_price": 0,
                    "label": "Falha na liberação da dieta vo (via oral)",
                    "value": "falha_na_liberacao_da_dieta_vo_via_oral",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 139,
                    "recurring_price": 0,
                    "label": "Falha na organização do prontuário",
                    "value": "falha_na_organizacao_do_prontuario",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 140,
                    "recurring_price": 0,
                    "label": "Falha na orientação/educação do paciente ou família",
                    "value": "falha_na_orientacao_educacao_do_paciente_ou_familia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 141,
                    "recurring_price": 0,
                    "label": "Falha na passagem de plantão",
                    "value": "falha_na_passagem_de_plantao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 142,
                    "recurring_price": 0,
                    "label": "Falha na prescrição da dieta",
                    "value": "falha_na_prescricao_da_dieta",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 143,
                    "recurring_price": 0,
                    "label": "Falha na prescrição do hemocomponente",
                    "value": "falha_na_prescricao_do_hemocomponente",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 144,
                    "recurring_price": 0,
                    "label": "Falha na prescrição médica",
                    "value": "falha_na_prescricao_medica",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 145,
                    "recurring_price": 0,
                    "label": "Falha na reserva de sangue",
                    "value": "falha_na_reserva_de_sangue",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 146,
                    "recurring_price": 0,
                    "label": "Falha na rotina de manutenção preventiva",
                    "value": "falha_na_rotina_de_manutencao_preventiva",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 147,
                    "recurring_price": 0,
                    "label": "Falha na rotulação dos cilindros",
                    "value": "falha_na_rotulacao_dos_cilindros",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 148,
                    "recurring_price": 0,
                    "label": "Falha na rotulagem de material ou instrumentais",
                    "value": "falha_na_rotulagem_de_material_ou_instrumentais",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 149,
                    "recurring_price": 0,
                    "label": "Falha na sinalização do teste vo com a fonoaudiologia",
                    "value": "falha_na_sinalizacao_do_teste_vo_com_a_fonoaudiologia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 150,
                    "recurring_price": 0,
                    "label": "Falha na transcrição da prescrição",
                    "value": "falha_na_transcricao_da_prescricao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 151,
                    "recurring_price": 0,
                    "label": "Falha na transcrição médica",
                    "value": "falha_na_transcricao_medica",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 152,
                    "recurring_price": 0,
                    "label": "Falha na transfusão de hemocomponentes",
                    "value": "falha_na_transfusao_de_hemocomponentes",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 153,
                    "recurring_price": 0,
                    "label": "Falha na transição do cuidado/transporte",
                    "value": "falha_na_transicao_do_cuidado_transporte",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 154,
                    "recurring_price": 0,
                    "label": "Falha na troca do dispositivo",
                    "value": "falha_na_troca_do_dispositivo",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 155,
                    "recurring_price": 0,
                    "label": "Falha na troca ou identificação do acesso",
                    "value": "falha_na_troca_ou_identificacao_do_acesso",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 156,
                    "recurring_price": 0,
                    "label": "Falha nas atividades administrativas",
                    "value": "falha_nas_atividades_administrativas",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 157,
                    "recurring_price": 0,
                    "label": "Falha no abastecimento de água",
                    "value": "falha_no_abastecimento_de_agua",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 158,
                    "recurring_price": 0,
                    "label": "Falha no agendamento cirúrgico/exames",
                    "value": "falha_no_agendamento_cirurgico_exames",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 159,
                    "recurring_price": 0,
                    "label": "Falha no aprazamento do medicamento",
                    "value": "falha_no_aprazamento_do_medicamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 160,
                    "recurring_price": 0,
                    "label": "Falha no armazenamento",
                    "value": "falha_no_armazenamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 161,
                    "recurring_price": 0,
                    "label": "Falha no atendimento do time de resposta rápida (trr)",
                    "value": "falha_no_atendimento_do_time_de_resposta_rapida_trr",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 162,
                    "recurring_price": 0,
                    "label": "Falha no encaminhamento do paciente ao centro cirúrgico (com adornos, falha no jejum)",
                    "value": "falha_no_encaminhamento_do_paciente_ao_centro_cirurgico_com_adornos_ falha_no_jejum",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 163,
                    "recurring_price": 0,
                    "label": "Falha no fornecimento de gases",
                    "value": "falha_no_fornecimento_de_gases",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 164,
                    "recurring_price": 0,
                    "label": "Falha no gerador",
                    "value": "falha_no_gerador",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 165,
                    "recurring_price": 0,
                    "label": "Falha no procedimento de transplante ou enxerto",
                    "value": "falha_no_procedimento_de_transplante_ou_enxerto",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 166,
                    "recurring_price": 0,
                    "label": "Falha no processo de esterilização/desinfecção/limpeza",
                    "value": "falha_no_processo_de_esterilizacao_desinfeccao_limpeza",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 167,
                    "recurring_price": 0,
                    "label": "Falha no processo de limpeza (terminal, concorrente, outras)",
                    "value": "falha_no_processo_de_limpeza_terminal_concorrente_outras",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 168,
                    "recurring_price": 0,
                    "label": "Falha no protocolo de homônimos",
                    "value": "falha_no_protocolo_de_homonimos",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 169,
                    "recurring_price": 0,
                    "label": "Falha no protocolo de jejum",
                    "value": "falha_no_protocolo_de_jejum",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 170,
                    "recurring_price": 0,
                    "label": "Falha no rastreamento admissional",
                    "value": "falha_no_rastreamento_admissional",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 171,
                    "recurring_price": 0,
                    "label": "Falha no reabastecimento de gases",
                    "value": "falha_no_reabastecimento_de_gases",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 172,
                    "recurring_price": 0,
                    "label": "Falha no recebimento de medicamentos no setor",
                    "value": "falha_no_recebimento_de_medicamentos_no_setor",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 173,
                    "recurring_price": 0,
                    "label": "Falha no registro do paciente",
                    "value": "falha_no_registro_do_paciente",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 174,
                    "recurring_price": 0,
                    "label": "Falha no retorno do material ou instrumental a CME",
                    "value": "falha_no_retorno_do_material_ou_instrumental_a_cme",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 175,
                    "recurring_price": 0,
                    "label": "Falha no time in, sign in e time out",
                    "value": "falha_no_time_in_sign_in_e_time_out",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 176,
                    "recurring_price": 0,
                    "label": "Falha no transporte (escolha do nível, ausência de profissional/material, outros)",
                    "value": "falha_no_transporte_escolha_do_nivel_ausencia_de_profissional_material_outros",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 177,
                    "recurring_price": 0,
                    "label": "Falha nos testes pre-transfusionais",
                    "value": "falha_nos_testes_pre_transfusionais",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 178,
                    "recurring_price": 0,
                    "label": "Falha ocorridas em laboratórios clínicos ou de patologia",
                    "value": "falha_ocorridas_em_laboratorios_clinicos_ou_de_patologia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 179,
                    "recurring_price": 0,
                    "label": "Falha ou ausência de manutenção preventiva/corretiva",
                    "value": "falha_ou_ausencia_de_manutencao_preventiva_corretiva",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 180,
                    "recurring_price": 0,
                    "label": "Falha protocolo de tromboembolismo venoso (tev)",
                    "value": "falha_protocolo_de_tromboembolismo_venoso_tev",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 181,
                    "recurring_price": 0,
                    "label": "Falha relacionada a estrutura física",
                    "value": "falha_relacionada_a_estrutura_fisica",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 182,
                    "recurring_price": 0,
                    "label": "Falha relacionada a hemotransfusão",
                    "value": "falha_relacionada_a_hemotransfusao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 183,
                    "recurring_price": 0,
                    "label": "Falha relacionada a materiais",
                    "value": "falha_relacionada_a_materiais",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 184,
                    "recurring_price": 0,
                    "label": "Falha relacionada a recursos organizacionais",
                    "value": "falha_relacionada_a_recursos_organizacionais",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 185,
                    "recurring_price": 0,
                    "label": "Falta de amenities (sabonete, shampoo e outros)",
                    "value": "falta_de_amenities_sabonete_shampoo_e_outros",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 186,
                    "recurring_price": 0,
                    "label": "Falta de enxoval",
                    "value": "falta_de_enxoval",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 187,
                    "recurring_price": 0,
                    "label": "Falta de material/medicamento/OPME",
                    "value": "falta_de_material_medicamento_opme",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 188,
                    "recurring_price": 0,
                    "label": "Falta de uniforme",
                    "value": "falta_de_uniforme",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 189,
                    "recurring_price": 0,
                    "label": "Flebite",
                    "value": "flebite",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 190,
                    "recurring_price": 0,
                    "label": "Flebite (química ou mecânica)",
                    "value": "flebite_quimica_ou_mecanica",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 191,
                    "recurring_price": 0,
                    "label": "Força contundente (esmagamento, fricção e conflito)",
                    "value": "forca_contundente_esmagamento_fricção_e_conflito",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 192,
                    "recurring_price": 0,
                    "label": "Força mecânica (onda de choque ou contato de equipamento)",
                    "value": "forca_mecanica_onda_de_choque_ou_contato_de_equipamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 193,
                    "recurring_price": 0,
                    "label": "Força perfurante (corte, mordedura, inoculação de veneno, ferroada, picada)",
                    "value": "forca_perfurante_corte_mordedura_inoculacao_de_veneno_ferroada_picada",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 194,
                    "recurring_price": 0,
                    "label": "Gastrostomia",
                    "value": "gastrostomia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 195,
                    "recurring_price": 0,
                    "label": "Hematoma",
                    "value": "hematoma",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 196,
                    "recurring_price": 0,
                    "label": "Hemorragia após cirurgia",
                    "value": "hemorragia_apos_cirurgia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 197,
                    "recurring_price": 0,
                    "label": "Ilegibilidade/rasura",
                    "value": "ilegibilidade_rasura",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 198,
                    "recurring_price": 0,
                    "label": "Ileostomia",
                    "value": "ileostomia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 199,
                    "recurring_price": 0,
                    "label": "Inapropriado/danificado para a função",
                    "value": "inapropriado_danificado_para_a_funcao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 200,
                    "recurring_price": 0,
                    "label": "Infecção cruzada covid-19",
                    "value": "infeccao_cruzada_covid_19",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 201,
                    "recurring_price": 0,
                    "label": "Infecção relacionada a assistência à saúde",
                    "value": "infeccao_relacionada_a_assistencia_a_saude",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 202,
                    "recurring_price": 0,
                    "label": "Infiltração",
                    "value": "infiltracao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 203,
                    "recurring_price": 0,
                    "label": "Infusão/administração de dieta vencida",
                    "value": "infusao_administracao_de_dieta_vencida",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 204,
                    "recurring_price": 0,
                    "label": "Jejunostomia",
                    "value": "jejunostomia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 205,
                    "recurring_price": 0,
                    "label": "Laudo inadequado",
                    "value": "laudo_inadequado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 206,
                    "recurring_price": 0,
                    "label": "Lentidão do sistema",
                    "value": "lentidao_do_sistema",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 207,
                    "recurring_price": 0,
                    "label": "Lesão de orgão durante cirurgia",
                    "value": "lesao_de_orgao_durante_cirurgia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 208,
                    "recurring_price": 0,
                    "label": "Lesão periestomal (por gastrostomia/bolsa de colostomia e outros)",
                    "value": "lesao_periestomal_por_gastrostomia_bolsa_de_colostomia_e_outros",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 209,
                    "recurring_price": 0,
                    "label": "Lesão por pressão",
                    "value": "lesao_por_pressao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 210,
                    "recurring_price": 0,
                    "label": "Lesão por pressão adquirida no hospital",
                    "value": "lesao_por_pressao_adquirida_no_hospital",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 211,
                    "recurring_price": 0,
                    "label": "lesão por pressão relacionada a dispositivo médico",
                    "value": "lesao_por_pressao_relacionada_a_dispositivo_medico",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 212,
                    "recurring_price": 0,
                    "label": "Lesão presente na admissão do paciente no hospital (proveniente da residência ou outros)",
                    "value": "lesao_presente_na_admissao_do_paciente_no_hospital_proveniente_da_residencia_ou_outros",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 213,
                    "recurring_price": 0,
                    "label": "Lixeiras com sacos incorretos",
                    "value": "lixeiras_com_sacos_incorretos",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 214,
                    "recurring_price": 0,
                    "label": "Material/instrumental danificado",
                    "value": "material_instrumental_danificado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 215,
                    "recurring_price": 0,
                    "label": "Material/instrumental extraviado",
                    "value": "material_instrumental_extraviado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 216,
                    "recurring_price": 0,
                    "label": "Material/medicamento/OPME vencido/violado/danificado",
                    "value": "material_medicamento_opme_vencido_violado_danificado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 217,
                    "recurring_price": 0,
                    "label": "Material vencido ou violado",
                    "value": "material_vencido_ou_violado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 218,
                    "recurring_price": 0,
                    "label": "Mecanismo de lesão (exposição a baixa pressão)",
                    "value": "mecanismo_de_lesao_exposicao_a_baixa_pressao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 219,
                    "recurring_price": 0,
                    "label": "Mecanismo de lesão (exposição a eletricidade/radiação)",
                    "value": "mecanismo_de_lesao_exposicao_a_eletricidade_radiacao",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 220,
                    "recurring_price": 0,
                    "label": "Mecanismo de lesão (exposição a pressão do ar)",
                    "value": "mecanismo_de_lesao_exposicao_a_pressao_do_ar",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 221,
                    "recurring_price": 0,
                    "label": "Mecanismo de lesão (exposição a ruídos/vibrações)",
                    "value": "mecanismo_de_lesao_exposicao_a_ruidos_vibracoes",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 222,
                    "recurring_price": 0,
                    "label": "Mecanismo térmico (sobreaquecimento ou frio excessivo)",
                    "value": "mecanismo_termico_sobreaquecimento_ou_frio_excessivo",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 223,
                    "recurring_price": 0,
                    "label": "Não administração do medicamento prescrito",
                    "value": "nao_administracao_do_medicamento_prescrito",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 224,
                    "recurring_price": 0,
                    "label": "Não realização da coleta de exames solicitado",
                    "value": "nao_realizacao_da_coleta_de_exames_solicitado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 225,
                    "recurring_price": 0,
                    "label": "Não sinalização de resultados críticos",
                    "value": "nao_sinalizacao_de_resultados_criticos",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 226,
                    "recurring_price": 0,
                    "label": "Nefrostomia",
                    "value": "nefrostomia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 227,
                    "recurring_price": 0,
                    "label": "Objeto esquecido em cavidade após cirurgia",
                    "value": "objeto_esquecido_em_cavidade_apos_cirurgia",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 228,
                    "recurring_price": 0,
                    "label": "Ofensa verbal",
                    "value": "ofensa_verbal",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 229,
                    "recurring_price": 0,
                    "label": "Outras lesões (especificar)",
                    "value": "outras_lesoes_especificar",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 230,
                    "recurring_price": 0,
                    "label": "Outro",
                    "value": "outro",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 231,
                    "recurring_price": 0,
                    "label": "Outros (especificar problema e sistema)",
                    "value": "outros_especificar_problema_e_sistema",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 232,
                    "recurring_price": 0,
                    "label": "Perda de amostras para exames",
                    "value": "perda_de_amostras_para_exames",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 233,
                    "recurring_price": 0,
                    "label": "Perda de eficácia terapêutica do medicamento",
                    "value": "perda_de_eficacia_terapeutica_do_medicamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 234,
                    "recurring_price": 0,
                    "label": "Pneumotórax",
                    "value": "pneumotorax",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 235,
                    "recurring_price": 0,
                    "label": "Predial danificado",
                    "value": "predial_danificado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 236,
                    "recurring_price": 0,
                    "label": "Predial deteriorado",
                    "value": "predial_deteriorado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 237,
                    "recurring_price": 0,
                    "label": "Predial inadequado (ex: banheiro para cadeirante inadequado)",
                    "value": "predial_inadequado_ex__banheiro_para_cadeirante_inadequado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 238,
                    "recurring_price": 0,
                    "label": "Predial inexistente (estrutura física)",
                    "value": "predial_inexistente_estrutura_fisica",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 239,
                    "recurring_price": 0,
                    "label": "Presença de material/instrumental no enxoval",
                    "value": "presenca_de_material_instrumental_no_enxoval",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 240,
                    "recurring_price": 0,
                    "label": "Presença de peca anatômica no enxoval",
                    "value": "presenca_de_peca_anatomica_no_enxoval",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 241,
                    "recurring_price": 0,
                    "label": "Presença de perfurocortante no enxoval",
                    "value": "presenca_de_perfurocortante_no_enxoval",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 242,
                    "recurring_price": 0,
                    "label": "Presença de vetores",
                    "value": "presenca_de_vetores",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 243,
                    "recurring_price": 0,
                    "label": "Problemas com uso/abuso de substâncias",
                    "value": "problemas_com_uso_abuso_de_substancias",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 244,
                    "recurring_price": 0,
                    "label": "Procedimento clínico não realizado",
                    "value": "procedimento_clinico_nao_realizado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 245,
                    "recurring_price": 0,
                    "label": "Procedimento realizado incorretamente",
                    "value": "procedimento_realizado_incorretamente",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 246,
                    "recurring_price": 0,
                    "label": "Quase queda do paciente",
                    "value": "quase_queda_do_paciente",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 247,
                    "recurring_price": 0,
                    "label": "Queda do paciente",
                    "value": "queda_do_paciente",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 248,
                    "recurring_price": 0,
                    "label": "Queimadura",
                    "value": "queimadura",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 249,
                    "recurring_price": 0,
                    "label": "Queimadura de paciente",
                    "value": "queimadura_de_paciente",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 250,
                    "recurring_price": 0,
                    "label": "Queimadura por placa de bisturi",
                    "value": "queimadura_por_placa_de_bisturi",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 251,
                    "recurring_price": 0,
                    "label": "Reabordagem cirúrgica",
                    "value": "reabordagem_cirurgica",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 252,
                    "recurring_price": 0,
                    "label": "Reabordagem cirúrgica não programada",
                    "value": "reabordagem_cirurgica_nao_programada",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 253,
                    "recurring_price": 0,
                    "label": "Reação adversa ao medicamento",
                    "value": "reacao_adversa_ao_medicamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 254,
                    "recurring_price": 0,
                    "label": "Reação alérgica",
                    "value": "reacao_alergica",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 255,
                    "recurring_price": 0,
                    "label": "Reação transfusional",
                    "value": "reacao_transfusional",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 256,
                    "recurring_price": 0,
                    "label": "Skin tears",
                    "value": "skin_tears",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 257,
                    "recurring_price": 0,
                    "label": "Solicitação de novo envio de medicamento",
                    "value": "solicitacao_de_novo_envio_de_medicamento",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 258,
                    "recurring_price": 0,
                    "label": "Suspeita de medicamento falsificado",
                    "value": "suspeita_de_medicamento_falsificado",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 259,
                    "recurring_price": 0,
                    "label": "Transmissão cruzada covid-19",
                    "value": "transmissao_cruzada_covid_19",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 260,
                    "recurring_price": 0,
                    "label": "Troca de exames",
                    "value": "troca_de_exames",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 261,
                    "recurring_price": 0,
                    "label": "Troca de hemocomponentes",
                    "value": "troca_de_hemocomponentes",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 262,
                    "recurring_price": 0,
                    "label": "Troca/falha na identificação do frasco",
                    "value": "troca_falha_na_identificacao_do_frasco",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 263,
                    "recurring_price": 0,
                    "label": "Tromboembolismo venoso (TEV)",
                    "value": "tromboembolismo_venoso_tev",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "",
                    "price": 0,
                    "index": 264,
                    "recurring_price": 0,
                    "label": "Uso inadequado do enxoval",
                    "value": "uso_inadequado_do_enxoval",
                    "price_currency": ""
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 265,
                    "recurring_price": 0,
                    "label": "Falha na transição do cuidado/transporte",
                    "value": "falha_na_transicao_do_cuidado/transporte",
                    "price_currency": "BRL"
                  }
                ],
                "value": "",
                "dynamic_value_dot_walk_path": "",
                "help_text": "",
                "max_length": 0,
                "order": 1700
              },
              {
                "active": true,
                "label": "Envolve Paciente:",
                "dynamic_value_field": "",
                "type": 5,
                "mandatory": true,
                "displayvalue": "Falso",
                "friendly_type": "select_box",
                "display_type": "Selecionar Caixa",
                "render_label": true,
                "read_only": false,
                "name": "involves_patient",
                "attributes": "edge_encryption_enabled=true",
                "id": "2c93c6bb1bd1251060d9426fe54bcb59",
                "choices": [
                  {
                    "index": 0,
                    "label": "-- Nenhum --",
                    "value": ""
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 1,
                    "recurring_price": 0,
                    "label": "Verdadeiro",
                    "value": "true",
                    "price_currency": "BRL"
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 2,
                    "recurring_price": 0,
                    "label": "Falso",
                    "value": "false",
                    "price_currency": "BRL"
                  }
                ],
                "value": "false",
                "dynamic_value_dot_walk_path": "",
                "help_text": "",
                "max_length": 0,
                "order": 1800
              },
              {
                "active": true,
                "label": "Classificação do Incidente:",
                "dynamic_value_field": "",
                "type": 5,
                "mandatory": true,
                "displayvalue": "",
                "friendly_type": "select_box",
                "display_type": "Selecionar Caixa",
                "render_label": true,
                "read_only": false,
                "name": "damage_level",
                "attributes": "edge_encryption_enabled=true",
                "id": "bd6206fb1bd1251060d9426fe54bcbcc",
                "choices": [
                  {
                    "index": 0,
                    "label": "-- Nenhum --",
                    "value": ""
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 1,
                    "recurring_price": 0,
                    "label": "Circunstância notificável",
                    "value": "19d0c798db76a1108394816404961944",
                    "price_currency": "BRL"
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 2,
                    "recurring_price": 0,
                    "label": " Near miss (Quase erro)",
                    "value": "0bd6cbdcdb76a110839481640496192f",
                    "price_currency": "BRL"
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 3,
                    "recurring_price": 0,
                    "label": "Incidente sem dano",
                    "value": "62270310dbb6a1108394816404961970",
                    "price_currency": "BRL"
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 4,
                    "recurring_price": 0,
                    "label": "Incidente com dano leve",
                    "value": "6e37039cdb76a110839481640496191f",
                    "price_currency": "BRL"
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 5,
                    "recurring_price": 0,
                    "label": "Incidente com dano moderado",
                    "value": "cbd08798db76a11083948164049619e2",
                    "price_currency": "BRL"
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 6,
                    "recurring_price": 0,
                    "label": "Incidente com dano grave",
                    "value": "5b180b9cdb76a1108394816404961964",
                    "price_currency": "BRL"
                  },
                  {
                    "recurring_price_currency": "BRL",
                    "price": 0,
                    "index": 7,
                    "recurring_price": 0,
                    "label": "Incidente com ÓBITO",
                    "value": "fa57f3dc1bb2e11060d9426fe54bcb83",
                    "price_currency": "BRL"
                  }
                ],
                "value": "",
                "dynamic_value_dot_walk_path": "",
                "help_text": "",
                "max_length": 0,
                "order": 2000
              },
              {
                "active": true,
                "label": "formatter",
                "dynamic_value_field": "",
                "type": 12,
                "mandatory": false,
                "displayvalue": "",
                "friendly_type": "break",
                "display_type": "Interrupção",
                "render_label": false,
                "read_only": false,
                "name": "formatter13",
                "attributes": "edge_encryption_enabled=true",
                "id": "a5d5b23f1b95251060d9426fe54bcba0",
                "value": "",
                "dynamic_value_dot_walk_path": "",
                "help_text": "",
                "max_length": 0,
                "order": 2200
              },
              {
                "containerSplitId": null,
                "type": 19,
                "mandatory": false,
                "friendly_type": "container_start",
                "display_type": "Início do Contêiner",
                "read_only": false,
                "children": [
                  {
                    "active": true,
                    "label": "Tipo do documento",
                    "dynamic_value_field": "",
                    "type": 3,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "multiple_choice",
                    "display_type": "Múltipla Escolha",
                    "render_label": true,
                    "read_only": false,
                    "name": "document_type",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "84158e7f1bd1251060d9426fe54bcb22",
                    "choices": [
                      {
                        "recurring_price_currency": "BRL",
                        "price": 0,
                        "index": 0,
                        "recurring_price": 0,
                        "label": "Atendimento",
                        "value": "atendimento",
                        "price_currency": "BRL"
                      },
                      {
                        "recurring_price_currency": "BRL",
                        "price": 0,
                        "index": 1,
                        "recurring_price": 0,
                        "label": "Prontuário",
                        "value": "prontuario",
                        "price_currency": "BRL"
                      }
                    ],
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 2400
                  },
                  {
                    "active": true,
                    "label": "Iniciais do paciente",
                    "dynamic_value_field": "",
                    "type": 6,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "single_line_text",
                    "display_type": "Texto de Linha Única",
                    "render_label": true,
                    "read_only": false,
                    "name": "patient_initials",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "dc374eff1bd1251060d9426fe54bcb33",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 2500
                  },
                  {
                    "active": true,
                    "label": "Gênero do paciente",
                    "dynamic_value_field": "",
                    "type": 5,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "select_box",
                    "display_type": "Selecionar Caixa",
                    "render_label": true,
                    "read_only": false,
                    "name": "patient_gender",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "d68746331b15251060d9426fe54bcb7f",
                    "choices": [
                      {
                        "index": 0,
                        "label": "-- Nenhum --",
                        "value": ""
                      },
                      {
                        "recurring_price_currency": "BRL",
                        "price": 0,
                        "index": 1,
                        "recurring_price": 0,
                        "label": "Feminino",
                        "value": "feminino",
                        "price_currency": "BRL"
                      },
                      {
                        "recurring_price_currency": "BRL",
                        "price": 0,
                        "index": 2,
                        "recurring_price": 0,
                        "label": "Masculino",
                        "value": "masculino",
                        "price_currency": "BRL"
                      },
                      {
                        "recurring_price_currency": "BRL",
                        "price": 0,
                        "index": 3,
                        "recurring_price": 0,
                        "label": "Outro",
                        "value": "outro",
                        "price_currency": "BRL"
                      }
                    ],
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 2600
                  },
                  {
                    "active": true,
                    "label": "Número do documento",
                    "dynamic_value_field": "",
                    "type": 6,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "single_line_text",
                    "display_type": "Texto de Linha Única",
                    "render_label": true,
                    "read_only": false,
                    "name": "document_number",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "9a8546bf1bd1251060d9426fe54bcb9c",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 2800
                  },
                  {
                    "active": true,
                    "label": "Data de nascimento do paciente",
                    "dynamic_value_field": "",
                    "type": 9,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "date",
                    "display_type": "Data",
                    "render_label": true,
                    "read_only": false,
                    "name": "patient_date_of_birth",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "e74742331b15251060d9426fe54bcb89",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "t_value": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 2900
                  },
                  {
                    "active": true,
                    "label": "formatter",
                    "dynamic_value_field": "",
                    "type": 12,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "break",
                    "display_type": "Interrupção",
                    "render_label": false,
                    "read_only": false,
                    "name": "formatter14",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "b2e7f6bf1b95251060d9426fe54bcbf7",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 3100
                  },
                  {
                    "active": true,
                    "label": "Título do incidente",
                    "dynamic_value_field": "",
                    "type": 6,
                    "mandatory": true,
                    "displayvalue": "",
                    "friendly_type": "single_line_text",
                    "display_type": "Texto de Linha Única",
                    "render_label": true,
                    "read_only": false,
                    "name": "incident_title",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "f3b23a3b1b95251060d9426fe54bcb23",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 3300
                  },
                  {
                    "active": true,
                    "label": "Descrição do incidente",
                    "dynamic_value_field": "",
                    "type": 2,
                    "mandatory": true,
                    "displayvalue": "",
                    "friendly_type": "multi_line_text",
                    "display_type": "Texto de Várias Linhas",
                    "render_label": true,
                    "read_only": false,
                    "name": "incident_description",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "1de2ba3b1b95251060d9426fe54bcbc5",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 3400
                  },
                  {
                    "active": true,
                    "label": "Ação corretiva imediata",
                    "dynamic_value_field": "",
                    "type": 2,
                    "mandatory": true,
                    "displayvalue": "",
                    "friendly_type": "multi_line_text",
                    "display_type": "Texto de Várias Linhas",
                    "render_label": true,
                    "read_only": false,
                    "name": "immediate_corrective_action",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "93037e3b1b95251060d9426fe54bcb88",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 3600
                  },
                  {
                    "active": true,
                    "label": "Fatores contribuintes",
                    "dynamic_value_field": "",
                    "type": 2,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "multi_line_text",
                    "display_type": "Texto de Várias Linhas",
                    "render_label": true,
                    "read_only": false,
                    "name": "contributing_mitigating_factors",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "ac83b6f71b95251060d9426fe54bcb3c",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 3700
                  },
                  {
                    "active": true,
                    "label": "Fatores contribuintes",
                    "dynamic_value_field": "",
                    "type": 2,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "multi_line_text",
                    "display_type": "Texto de Várias Linhas",
                    "render_label": true,
                    "read_only": false,
                    "name": "mitigating_factors",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "3c2a89dc1b83a15060d9426fe54bcb30",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 3800
                  },
                  {
                    "active": true,
                    "label": "Notificação Lida",
                    "dynamic_value_field": "",
                    "type": 5,
                    "mandatory": false,
                    "displayvalue": "false",
                    "friendly_type": "select_box",
                    "display_type": "Selecionar Caixa",
                    "render_label": true,
                    "read_only": false,
                    "name": "u_notification_read",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "26fe7df3dbe32910839481640496195f",
                    "choices": [
                      {
                        "index": 0,
                        "label": "-- Nenhum --",
                        "value": ""
                      }
                    ],
                    "value": "false",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 3900
                  },
                  {
                    "active": true,
                    "label": "Motivo do arquivamento",
                    "dynamic_value_field": "",
                    "type": 5,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "select_box",
                    "display_type": "Selecionar Caixa",
                    "render_label": true,
                    "read_only": false,
                    "name": "u_reason_for_archiving",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "815ab1bfdba3291083948164049619f2",
                    "choices": [
                      {
                        "index": 0,
                        "label": "-- Nenhum --",
                        "value": ""
                      },
                      {
                        "recurring_price_currency": "BRL",
                        "price": 0,
                        "index": 1,
                        "recurring_price": 0,
                        "label": "Notificação Improcedente",
                        "value": "unfounded_notification",
                        "price_currency": "BRL"
                      },
                      {
                        "recurring_price_currency": "BRL",
                        "price": 0,
                        "index": 2,
                        "recurring_price": 0,
                        "label": "Notificação Duplicada",
                        "value": "duplicate_notification",
                        "price_currency": "BRL"
                      },
                      {
                        "recurring_price_currency": "BRL",
                        "price": 0,
                        "index": 3,
                        "recurring_price": 0,
                        "label": "Outros",
                        "value": "others",
                        "price_currency": "BRL"
                      }
                    ],
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 4000
                  },
                  {
                    "active": true,
                    "label": "Observações",
                    "dynamic_value_field": "",
                    "type": 2,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "multi_line_text",
                    "display_type": "Texto de Várias Linhas",
                    "render_label": true,
                    "read_only": false,
                    "name": "u_archiving_observations",
                    "attributes": "edge_encryption_enabled=true,max_length=2000",
                    "id": "19acb133dbe3291083948164049619ea",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 4100
                  },
                  {
                    "active": true,
                    "label": "Classificação da notificação",
                    "dynamic_value_field": "",
                    "type": 5,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "select_box",
                    "display_type": "Selecionar Caixa",
                    "render_label": true,
                    "read_only": false,
                    "name": "u_incident_classification",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "21c274dbdb40351083948164049619c3",
                    "choices": [
                      {
                        "index": 0,
                        "label": "-- Nenhum --",
                        "value": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 1,
                        "recurring_price": 0,
                        "label": "Interna",
                        "value": "u_incident_classification_internal",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 2,
                        "recurring_price": 0,
                        "label": "Externa",
                        "value": "u_incident_classification_external",
                        "price_currency": ""
                      }
                    ],
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 4200
                  },
                  {
                    "active": true,
                    "label": "Risco de imagem",
                    "dynamic_value_field": "",
                    "type": 5,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "select_box",
                    "display_type": "Selecionar Caixa",
                    "render_label": true,
                    "read_only": false,
                    "name": "u_image_risk",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "2872fc9bdb40351083948164049619a4",
                    "choices": [
                      {
                        "index": 0,
                        "label": "-- Nenhum --",
                        "value": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 1,
                        "recurring_price": 0,
                        "label": "Sim",
                        "value": "u_image_risk_yes",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 2,
                        "recurring_price": 0,
                        "label": "Não",
                        "value": "u_image_risk_no",
                        "price_currency": ""
                      }
                    ],
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 4300
                  },
                  {
                    "active": true,
                    "label": "Tipo do incidente reclassificado",
                    "dynamic_value_field": "",
                    "type": 5,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "select_box",
                    "display_type": "Selecionar Caixa",
                    "render_label": true,
                    "read_only": false,
                    "name": "u_reclassified_incident_type",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "92aeec97db4035108394816404961962",
                    "choices": [
                      {
                        "index": 0,
                        "label": "-- Nenhum --",
                        "value": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 1,
                        "recurring_price": 0,
                        "label": "Abertura involuntária da ferida operatória (deiscência)",
                        "value": "abertura_involuntaria_da_ferida_operatoria_deiscencia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 2,
                        "recurring_price": 0,
                        "label": "Agressão física",
                        "value": "agressao_fisica",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 3,
                        "recurring_price": 0,
                        "label": "Agressão sexual",
                        "value": "agressao_sexual",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 4,
                        "recurring_price": 0,
                        "label": "Alocação incorreta de paciente",
                        "value": "alocacao_incorreta_de_paciente",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 5,
                        "recurring_price": 0,
                        "label": "Ameaça a respiração (sufocamento e confinamento)",
                        "value": "ameaca_a_respiracao_sufocamento_e_confinamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 6,
                        "recurring_price": 0,
                        "label": "Ameaça de morte",
                        "value": "ameaca_de_morte",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 7,
                        "recurring_price": 0,
                        "label": "Atraso de entrega de refeição pelo restaurante",
                        "value": "atraso_de_entrega_de_refeicao_pelo_restaurante",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 8,
                        "recurring_price": 0,
                        "label": "Atraso do procedimento cirúrgico",
                        "value": "atraso_do_procedimento_cirurgico",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 9,
                        "recurring_price": 0,
                        "label": "Atraso/falha na entrega de insumos pelo restaurante",
                        "value": "atraso_falha_na_entrega_de_insumos_pelo_restaurante",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 10,
                        "recurring_price": 0,
                        "label": "Atraso/falha na retirada de bandeja/utensílios do box/quarto",
                        "value": "atraso_falha_na_retirada_de_bandeja_utensilios_do_box_quarto",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 11,
                        "recurring_price": 0,
                        "label": "Atraso/falha no abastecimento do arsenal/almoxarifado",
                        "value": "atraso_falha_no_abastecimento_do_arsenal_almoxarifado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 12,
                        "recurring_price": 0,
                        "label": "Atraso na coleta de exames",
                        "value": "atraso_na_coleta_de_exames",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 13,
                        "recurring_price": 0,
                        "label": "Atraso na entrega da dieta",
                        "value": "atraso_na_entrega_da_dieta",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 14,
                        "recurring_price": 0,
                        "label": "Atraso na entrega de exames",
                        "value": "atraso_na_entrega_de_exames",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 15,
                        "recurring_price": 0,
                        "label": "Atraso na entrega medicamento",
                        "value": "atraso_na_entrega_medicamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 16,
                        "recurring_price": 0,
                        "label": "Atraso na entrega/reposição de uniformes",
                        "value": "atraso_na_entrega_reposicao_de_uniformes",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 17,
                        "recurring_price": 0,
                        "label": "Atraso na infusão de hemocomponentes",
                        "value": "atraso_na_infusão_de_hemocomponentes",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 18,
                        "recurring_price": 0,
                        "label": "Atraso na internação dos pacientes",
                        "value": "atraso_na_internacao_dos_pacientes",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 19,
                        "recurring_price": 0,
                        "label": "Atraso na liberação de laudos/resultados",
                        "value": "atraso_na_liberacao_de_laudos_resultados",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 20,
                        "recurring_price": 0,
                        "label": "Atraso na limpeza do leito/quarto/sala cirúrgica",
                        "value": "atraso_na_limpeza_do_leito_quarto_sala_cirurgica",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 21,
                        "recurring_price": 0,
                        "label": "Atraso na realização/coleta de exames",
                        "value": "atraso_na_realizacao_coleta_de_exames",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 22,
                        "recurring_price": 0,
                        "label": "Atraso na realização de exames",
                        "value": "atraso_na_realizacao_de_exames",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 23,
                        "recurring_price": 0,
                        "label": "Atraso na reposição de material ou medicamento",
                        "value": "atraso_na_reposicao_de_material_ou_medicamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 24,
                        "recurring_price": 0,
                        "label": "Atraso na reposição do enxoval",
                        "value": "atraso_na_reposicao_do_enxoval",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 25,
                        "recurring_price": 0,
                        "label": "Atraso no atendimento da manutenção",
                        "value": "atraso_no_atendimento_da_manutencao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 26,
                        "recurring_price": 0,
                        "label": "Ausência/dano na pulseira de identificação",
                        "value": "ausencia_dano_na_pulseira_de_identificacao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 27,
                        "recurring_price": 0,
                        "label": "Ausência de código de barra/rastreabilidade",
                        "value": "ausencia_de_codigo_de_barra_rastreabilidade",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 28,
                        "recurring_price": 0,
                        "label": "Ausência de pulseira de queda",
                        "value": "ausencia_de_pulseira_de_queda",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 29,
                        "recurring_price": 0,
                        "label": "Ausência de rastreabilidade",
                        "value": "ausencia_de_rastreabilidade",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 30,
                        "recurring_price": 0,
                        "label": "Ausência/falha na devolução do material/medicamento",
                        "value": "ausencia_falha_na_devolucao_do_material_medicamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 31,
                        "recurring_price": 0,
                        "label": "Ausência/falha na extensão do dispositivo (ausência de polifix, equipo ou torneira se necessário)",
                        "value": "ausencia_falha_na_extensao_do_dispositivo_ausencia_de_polifix_equipo_ou_torneira_se_necessario",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 32,
                        "recurring_price": 0,
                        "label": "Ausência/falha no preenchimento dos documentos",
                        "value": "ausencia_falha_no_preenchimento_dos_documentos",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 33,
                        "recurring_price": 0,
                        "label": "Broncoaspiração",
                        "value": "broncoaspiracao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 34,
                        "recurring_price": 0,
                        "label": "Cadastro errado de médico assistente (CRM, especialidade, nome)",
                        "value": "cadastro_errado_de_medico_assistente_crm_especialidade_nome",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 35,
                        "recurring_price": 0,
                        "label": "Cadastro errado de paciente",
                        "value": "cadastro_errado_de_paciente",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 36,
                        "recurring_price": 0,
                        "label": "Cadastro errado do convenio",
                        "value": "cadastro_errado_do_convenio",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 37,
                        "recurring_price": 0,
                        "label": "Cancelamento de exames",
                        "value": "cancelamento_de_exames",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 38,
                        "recurring_price": 0,
                        "label": "Cancelamento de procedimento cirúrgico",
                        "value": "cancelamento_de_procedimento_cirurgico",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 39,
                        "recurring_price": 0,
                        "label": "Cânula de traqueostomia",
                        "value": "canula_de_traqueostomia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 40,
                        "recurring_price": 0,
                        "label": "Cânula endotraqueal",
                        "value": "canula_endotraqueal",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 41,
                        "recurring_price": 0,
                        "label": "Cateter arterial",
                        "value": "cateter_arterial",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 42,
                        "recurring_price": 0,
                        "label": "Cateter central de inserção periférica (picc)",
                        "value": "cateter_central_de_insercao_periferica_picc",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 43,
                        "recurring_price": 0,
                        "label": "Cateter de monitorização intracraniana (pic)",
                        "value": "cateter_de_monitorizacao_intracraniana_pic",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 44,
                        "recurring_price": 0,
                        "label": "Cateter nasoentérico",
                        "value": "cateter_nasoenterico",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 45,
                        "recurring_price": 0,
                        "label": "Cateter nasogástrico",
                        "value": "cateter_nasogastrico",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 46,
                        "recurring_price": 0,
                        "label": "Cateter tenckhoff",
                        "value": "cateter_tenckhoff",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 47,
                        "recurring_price": 0,
                        "label": "Cateter venoso central",
                        "value": "cateter_venoso_central",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 48,
                        "recurring_price": 0,
                        "label": "Cateter venoso periférico",
                        "value": "cateter_venoso_periferico",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 49,
                        "recurring_price": 0,
                        "label": "Cateter vesical de demora",
                        "value": "cateter_vesical_de_demora",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 50,
                        "recurring_price": 0,
                        "label": "Cilindro danificado",
                        "value": "cilindro_danificado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 51,
                        "recurring_price": 0,
                        "label": "Cirurgia em membro ou local errado",
                        "value": "cirurgia_em_membro_ou_local_errado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 52,
                        "recurring_price": 0,
                        "label": "Cirurgia em órgão errado",
                        "value": "cirurgia_em_orgao_errado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 53,
                        "recurring_price": 0,
                        "label": "Cirurgia em paciente errado",
                        "value": "cirurgia_em_paciente_errado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 54,
                        "recurring_price": 0,
                        "label": "Cirurgia Suspensa",
                        "value": "cirurgia_suspensa",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 55,
                        "recurring_price": 0,
                        "label": "Cobrança indevida do medicamento",
                        "value": "cobranca_indevida_do_medicamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 56,
                        "recurring_price": 0,
                        "label": "Colonostomia",
                        "value": "colonostomia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 57,
                        "recurring_price": 0,
                        "label": "Comportamento inadequado",
                        "value": "comportamento_inadequado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 58,
                        "recurring_price": 0,
                        "label": "Dai (dermatite associada a incontinência)",
                        "value": "dai_dermatite_associada_a_incontinencia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 59,
                        "recurring_price": 0,
                        "label": "Dano infligido a si próprio/suicídio",
                        "value": "dano_infligido_a_si_proprio_suicidio",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 60,
                        "recurring_price": 0,
                        "label": "Danos contra bens",
                        "value": "danos_contra_bens",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 61,
                        "recurring_price": 0,
                        "label": "Dermatite",
                        "value": "dermatite",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 62,
                        "recurring_price": 0,
                        "label": "Descarte de perfurocortantes em recipiente inadequado (saco, lixeiras, outros)",
                        "value": "descarte_de_perfurocortantes_em_recipiente_inadequado_saco_lixeiras_outros",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 63,
                        "recurring_price": 0,
                        "label": "Descarte inadequado de enxoval/uniformes",
                        "value": "descarte_inadequado_de_enxoval_uniformes",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 64,
                        "recurring_price": 0,
                        "label": "Descumprimento da nr32",
                        "value": "descumprimento_da_nr32",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 65,
                        "recurring_price": 0,
                        "label": "Desvio de qualidade de produtos",
                        "value": "desvio_de_qualidade_de_produtos",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 66,
                        "recurring_price": 0,
                        "label": "Desvio de qualidade do medicamento",
                        "value": "desvio_de_qualidade_do_medicamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 67,
                        "recurring_price": 0,
                        "label": "Desvio de qualidade no alimento/dieta",
                        "value": "desvio_de_qualidade_no_alimento_dieta",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 68,
                        "recurring_price": 0,
                        "label": "Desvio de qualidade no envio do anatomopatológico",
                        "value": "desvio_de_qualidade_no_envio_do_anatomopatologico",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 69,
                        "recurring_price": 0,
                        "label": "Dieta errada",
                        "value": "dieta_errada",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 70,
                        "recurring_price": 0,
                        "label": "Dieta oral com consistência inadequada",
                        "value": "dieta_oral_com_consistencia_inadequada",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 71,
                        "recurring_price": 0,
                        "label": "Dreno",
                        "value": "dreno",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 72,
                        "recurring_price": 0,
                        "label": "Embolia Pulmonar",
                        "value": "embolia_pulmonar",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 73,
                        "recurring_price": 0,
                        "label": "Envio duplicado de medicamento",
                        "value": "envio_duplicado_de_medicamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 74,
                        "recurring_price": 0,
                        "label": "Enxoval danificado",
                        "value": "enxoval_danificado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 75,
                        "recurring_price": 0,
                        "label": "Equipamento/infraestrutura danificado",
                        "value": "equipamento_infraestrutura_danificado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 76,
                        "recurring_price": 0,
                        "label": "Equipamento/infraestrutura deteriorado",
                        "value": "equipamento_infraestrutura_deteriorado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 77,
                        "recurring_price": 0,
                        "label": "Equipamento/infraestrutura inadequado",
                        "value": "equipamento_infraestrutura_inadequado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 78,
                        "recurring_price": 0,
                        "label": "Equipamento/infraestrutura inexistente",
                        "value": "equipamento_infraestrutura_inexistente",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 79,
                        "recurring_price": 0,
                        "label": "Erro de prescrição",
                        "value": "erro_de_prescricao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 80,
                        "recurring_price": 0,
                        "label": "Evasão do paciente",
                        "value": "evasao_do_paciente",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 81,
                        "recurring_price": 0,
                        "label": "Evasão do paciente (do leito ou do hospital)",
                        "value": "evasao_do_paciente_do leito_ou_do_hospital",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 82,
                        "recurring_price": 0,
                        "label": "Evento relacionado a procedimento médico/complicações potenciais do procedimento",
                        "value": "evento_relacionado_a_procedimento_medico_complicacoes_potenciais_do_procedimento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 83,
                        "recurring_price": 0,
                        "label": "Exposição a substância (envenenamento ou corrosão)",
                        "value": "exposicao_a_substancia_envenenamento_ou_corrosao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 84,
                        "recurring_price": 0,
                        "label": "Exposição repetida de órgãos pela ferida operatória após a cirurgia (evisceração)",
                        "value": "exposicao_repetida_de_orgaos_pela_ferida_operatoria_apos_a_cirurgia_evisceracao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 85,
                        "recurring_price": 0,
                        "label": "Extravasamento (contraste/quimio ou medicamentos)",
                        "value": "extravasamento_contraste_quimio_ou_medicamentos",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 86,
                        "recurring_price": 0,
                        "label": "Extravasamento pelo óstio (cateter ou gastrostomia)",
                        "value": "extravasamento_pelo_ostio_cateter_ou_gastrostomia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 87,
                        "recurring_price": 0,
                        "label": "Extravio/ausência de documento",
                        "value": "extravio_ausencia_de_documento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 88,
                        "recurring_price": 0,
                        "label": "Extubação acidental",
                        "value": "extubacao_acidental",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 89,
                        "recurring_price": 0,
                        "label": "Extubação endotraqueal acidental",
                        "value": "extubacao_endotraqueal_acidental",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 90,
                        "recurring_price": 0,
                        "label": "Falha/atraso na entrega de insumos",
                        "value": "falha_atraso_na_entrega_de_insumos",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 91,
                        "recurring_price": 0,
                        "label": "Falha/atraso na liberação do paciente do centro cirúrgico",
                        "value": "falha_atraso_na_liberacao_do_paciente_do_centro_cirurgico",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 92,
                        "recurring_price": 0,
                        "label": "Falha/ausência da identificação da alergia",
                        "value": "falha_ausencia_da_identificacao_da_alergia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 93,
                        "recurring_price": 0,
                        "label": "Falha/ausência de comunicação entre os setores",
                        "value": "falha_ausencia_de_comunicacao_entre_os_setores",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 94,
                        "recurring_price": 0,
                        "label": "Falha/ausência de comunicação na passagem do caso do paciente",
                        "value": "falha_ausencia_de_comunicacao_na_passagem_do_caso_do_paciente",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 95,
                        "recurring_price": 0,
                        "label": "Falha/ausência na comunicação de laudos/resultados críticos",
                        "value": "falha_ausencia_na_comunicacao_de_laudos_resultados_criticos",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 96,
                        "recurring_price": 0,
                        "label": "Falha/ausência no uso do epi",
                        "value": "falha_ausencia_no_uso_do_epi",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 97,
                        "recurring_price": 0,
                        "label": "Falha de equipamento",
                        "value": "falha_de_equipamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 98,
                        "recurring_price": 0,
                        "label": "Falha do atendimento no guarda-volumes",
                        "value": "falha_do_atendimento_no_guarda_volumes",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 99,
                        "recurring_price": 0,
                        "label": "Falha durante a assistência à saúde",
                        "value": "falha_durante_a_assistencia_a_saude",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 100,
                        "recurring_price": 0,
                        "label": "Falha durante o procedimento cirúrgico",
                        "value": "falha_durante_o_procedimento_cirurgico",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 101,
                        "recurring_price": 0,
                        "label": "Falha em equipamentos médico-hospitalares em uso",
                        "value": "falha_em_equipamentos_medico_hospitalares_em_uso",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 102,
                        "recurring_price": 0,
                        "label": "Falha envolvendo cateter venoso",
                        "value": "falha_envolvendo_cateter_venoso",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 103,
                        "recurring_price": 0,
                        "label": "Falha envolvendo dietas",
                        "value": "falha_envolvendo_dietas",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 104,
                        "recurring_price": 0,
                        "label": "Falha envolvendo sondas",
                        "value": "falha_envolvendo_sondas",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 105,
                        "recurring_price": 0,
                        "label": "Falha na abertura da gaveta ou no cartucho",
                        "value": "falha_na_abertura_da_gaveta_ou_no_cartucho",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 106,
                        "recurring_price": 0,
                        "label": "Falha na abertura de documentos",
                        "value": "falha_na_abertura_de_documentos",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 107,
                        "recurring_price": 0,
                        "label": "Falha na adesão aos bundles/pacote de medidas de prevenção",
                        "value": "falha_na_adesao_aos_bundles_pacote_de_medidas_de_prevencao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 108,
                        "recurring_price": 0,
                        "label": "Falha na administração da dieta/suplementos",
                        "value": "falha_na_administracao_da_dieta_suplementos",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 109,
                        "recurring_price": 0,
                        "label": "Falha na administração de gases",
                        "value": "falha_na_administracao_de_gases",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 110,
                        "recurring_price": 0,
                        "label": "Falha na administração de O2 ou gases medicinais",
                        "value": "falha_na_administracao_de_o2_ou_gases_medicinais",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 111,
                        "recurring_price": 0,
                        "label": "Falha na administração do medicamento",
                        "value": "falha_na_administracao_do_medicamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 112,
                        "recurring_price": 0,
                        "label": "Falha na admissão do paciente no leito",
                        "value": "falha_na_admissao_do_paciente_no_leito",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 113,
                        "recurring_price": 0,
                        "label": "Falha na assistência radiológica",
                        "value": "falha_na_assistencia_radiologica",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 114,
                        "recurring_price": 0,
                        "label": "Falha na cadeia medicamentosa",
                        "value": "falha_na_cadeia_medicamentosa",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 115,
                        "recurring_price": 0,
                        "label": "Falha na campainha (chamada de enfermagem)",
                        "value": "falha_na_campainha_chamada_de_enfermagem",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 116,
                        "recurring_price": 0,
                        "label": "Falha na checagem",
                        "value": "falha_na_checagem",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 117,
                        "recurring_price": 0,
                        "label": "Falha na checagem da dieta/suplemento",
                        "value": "falha_na_checagem_da_dieta_suplemento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 118,
                        "recurring_price": 0,
                        "label": "Falha na codificação de cores",
                        "value": "falha_na_codificacao_de_cores",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 119,
                        "recurring_price": 0,
                        "label": "Falha na coleta dos exames ou nas amostras",
                        "value": "falha_na_coleta_dos_exames_ou_nas_amostras",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 120,
                        "recurring_price": 0,
                        "label": "Falha na comunicação da realização de exames (preparo, cancelamento, realização, outros)",
                        "value": "falha_na_comunicacao_da_realizacao_de_exames_preparo_cancelamento_realizacao_outros",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 121,
                        "recurring_price": 0,
                        "label": "Falha na comunicação na realização do transporte",
                        "value": "falha_na_comunicacao_na_realizacao_do_transporte",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 122,
                        "recurring_price": 0,
                        "label": "Falha na contenção física ou mecânica",
                        "value": "falha_na_contencao_fisica_ou_mecanica",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 123,
                        "recurring_price": 0,
                        "label": "Falha na detecção da deterioração clínica",
                        "value": "falha_na_deteccao_da_deterioracao_clinica",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 124,
                        "recurring_price": 0,
                        "label": "Falha na devolução do material",
                        "value": "falha_na_devolucao_do_material",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 125,
                        "recurring_price": 0,
                        "label": "Falha na digitalização do documento",
                        "value": "falha_na_digitalizacao_do_documento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 126,
                        "recurring_price": 0,
                        "label": "Falha na dispensação",
                        "value": "falha_na_dispensacao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 127,
                        "recurring_price": 0,
                        "label": "Falha na dispensação da dieta/suplementos (envio duplo de dieta, suplementos, outros)",
                        "value": "falha_na_dispensacao_da_dieta_suplementos_envio_duplo_de_dieta_suplementos_outros",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 128,
                        "recurring_price": 0,
                        "label": "Falha na dispensação do material ou medicamento",
                        "value": "falha_na_dispensacao_do_material_ou_medicamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 129,
                        "recurring_price": 0,
                        "label": "Falha na documentação",
                        "value": "falha_na_documentacao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 130,
                        "recurring_price": 0,
                        "label": "Falha na entrega do medicamento",
                        "value": "falha_na_entrega_do_medicamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 131,
                        "recurring_price": 0,
                        "label": "Falha na estabilização e/ou fixação do curativo",
                        "value": "falha_na_estabilizacao_e_ou_fixacao_do_curativo",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 132,
                        "recurring_price": 0,
                        "label": "Falha na higienização das mãos",
                        "value": "falha_na_higienizacao_das_maos",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 133,
                        "recurring_price": 0,
                        "label": "Falha na identificação da dieta",
                        "value": "falha_na_identificacao_da_dieta",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 134,
                        "recurring_price": 0,
                        "label": "Falha na identificação do paciente",
                        "value": "falha_na_identificacao_do_paciente",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 135,
                        "recurring_price": 0,
                        "label": "Falha na identificação do profissional no documento",
                        "value": "falha_na_identificacao_do_profissional_no_documento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 136,
                        "recurring_price": 0,
                        "label": "Falha na identificação do risco nutricional",
                        "value": "falha_na_identificacao_do_risco_nutricional",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 137,
                        "recurring_price": 0,
                        "label": "Falha na integração dos sistemas",
                        "value": "falha_na_integração_dos_sistemas",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 138,
                        "recurring_price": 0,
                        "label": "Falha na liberação da dieta vo (via oral)",
                        "value": "falha_na_liberacao_da_dieta_vo_via_oral",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 139,
                        "recurring_price": 0,
                        "label": "Falha na organização do prontuário",
                        "value": "falha_na_organizacao_do_prontuario",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 140,
                        "recurring_price": 0,
                        "label": "Falha na orientação/educação do paciente ou família",
                        "value": "falha_na_orientacao_educacao_do_paciente_ou_familia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 141,
                        "recurring_price": 0,
                        "label": "Falha na passagem de plantão",
                        "value": "falha_na_passagem_de_plantao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 142,
                        "recurring_price": 0,
                        "label": "Falha na prescrição da dieta",
                        "value": "falha_na_prescricao_da_dieta",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 143,
                        "recurring_price": 0,
                        "label": "Falha na prescrição do hemocomponente",
                        "value": "falha_na_prescricao_do_hemocomponente",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 144,
                        "recurring_price": 0,
                        "label": "Falha na prescrição médica",
                        "value": "falha_na_prescricao_medica",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 145,
                        "recurring_price": 0,
                        "label": "Falha na reserva de sangue",
                        "value": "falha_na_reserva_de_sangue",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 146,
                        "recurring_price": 0,
                        "label": "Falha na rotina de manutenção preventiva",
                        "value": "falha_na_rotina_de_manutencao_preventiva",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 147,
                        "recurring_price": 0,
                        "label": "Falha na rotulação dos cilindros",
                        "value": "falha_na_rotulacao_dos_cilindros",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 148,
                        "recurring_price": 0,
                        "label": "Falha na rotulagem de material ou instrumentais",
                        "value": "falha_na_rotulagem_de_material_ou_instrumentais",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 149,
                        "recurring_price": 0,
                        "label": "Falha na sinalização do teste vo com a fonoaudiologia",
                        "value": "falha_na_sinalizacao_do_teste_vo_com_a_fonoaudiologia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 150,
                        "recurring_price": 0,
                        "label": "Falha na transcrição da prescrição",
                        "value": "falha_na_transcricao_da_prescricao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 151,
                        "recurring_price": 0,
                        "label": "Falha na transcrição médica",
                        "value": "falha_na_transcricao_medica",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 152,
                        "recurring_price": 0,
                        "label": "Falha na transfusão de hemocomponentes",
                        "value": "falha_na_transfusao_de_hemocomponentes",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 153,
                        "recurring_price": 0,
                        "label": "Falha na transição do cuidado/transporte",
                        "value": "falha_na_transicao_do_cuidado_transporte",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 154,
                        "recurring_price": 0,
                        "label": "Falha na troca do dispositivo",
                        "value": "falha_na_troca_do_dispositivo",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 155,
                        "recurring_price": 0,
                        "label": "Falha na troca ou identificação do acesso",
                        "value": "falha_na_troca_ou_identificacao_do_acesso",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 156,
                        "recurring_price": 0,
                        "label": "Falha nas atividades administrativas",
                        "value": "falha_nas_atividades_administrativas",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 157,
                        "recurring_price": 0,
                        "label": "Falha no abastecimento de água",
                        "value": "falha_no_abastecimento_de_agua",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 158,
                        "recurring_price": 0,
                        "label": "Falha no agendamento cirúrgico/exames",
                        "value": "falha_no_agendamento_cirurgico_exames",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 159,
                        "recurring_price": 0,
                        "label": "Falha no aprazamento do medicamento",
                        "value": "falha_no_aprazamento_do_medicamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 160,
                        "recurring_price": 0,
                        "label": "Falha no armazenamento",
                        "value": "falha_no_armazenamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 161,
                        "recurring_price": 0,
                        "label": "Falha no atendimento do time de resposta rápida (trr)",
                        "value": "falha_no_atendimento_do_time_de_resposta_rapida_trr",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 162,
                        "recurring_price": 0,
                        "label": "Falha no encaminhamento do paciente ao centro cirúrgico (com adornos, falha no jejum)",
                        "value": "falha_no_encaminhamento_do_paciente_ao_centro_cirurgico_com_adornos_ falha_no_jejum",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 163,
                        "recurring_price": 0,
                        "label": "Falha no fornecimento de gases",
                        "value": "falha_no_fornecimento_de_gases",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 164,
                        "recurring_price": 0,
                        "label": "Falha no gerador",
                        "value": "falha_no_gerador",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 165,
                        "recurring_price": 0,
                        "label": "Falha no procedimento de transplante ou enxerto",
                        "value": "falha_no_procedimento_de_transplante_ou_enxerto",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 166,
                        "recurring_price": 0,
                        "label": "Falha no processo de esterilização/desinfecção/limpeza",
                        "value": "falha_no_processo_de_esterilizacao_desinfeccao_limpeza",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 167,
                        "recurring_price": 0,
                        "label": "Falha no processo de limpeza (terminal, concorrente, outras)",
                        "value": "falha_no_processo_de_limpeza_terminal_concorrente_outras",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 168,
                        "recurring_price": 0,
                        "label": "Falha no protocolo de homônimos",
                        "value": "falha_no_protocolo_de_homonimos",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 169,
                        "recurring_price": 0,
                        "label": "Falha no protocolo de jejum",
                        "value": "falha_no_protocolo_de_jejum",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 170,
                        "recurring_price": 0,
                        "label": "Falha no rastreamento admissional",
                        "value": "falha_no_rastreamento_admissional",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 171,
                        "recurring_price": 0,
                        "label": "Falha no reabastecimento de gases",
                        "value": "falha_no_reabastecimento_de_gases",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 172,
                        "recurring_price": 0,
                        "label": "Falha no recebimento de medicamentos no setor",
                        "value": "falha_no_recebimento_de_medicamentos_no_setor",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 173,
                        "recurring_price": 0,
                        "label": "Falha no registro do paciente",
                        "value": "falha_no_registro_do_paciente",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 174,
                        "recurring_price": 0,
                        "label": "Falha no retorno do material ou instrumental a CME",
                        "value": "falha_no_retorno_do_material_ou_instrumental_a_cme",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 175,
                        "recurring_price": 0,
                        "label": "Falha no time in, sign in e time out",
                        "value": "falha_no_time_in_sign_in_e_time_out",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 176,
                        "recurring_price": 0,
                        "label": "Falha no transporte (escolha do nível, ausência de profissional/material, outros)",
                        "value": "falha_no_transporte_escolha_do_nivel_ausencia_de_profissional_material_outros",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 177,
                        "recurring_price": 0,
                        "label": "Falha nos testes pre-transfusionais",
                        "value": "falha_nos_testes_pre_transfusionais",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 178,
                        "recurring_price": 0,
                        "label": "Falha ocorridas em laboratórios clínicos ou de patologia",
                        "value": "falha_ocorridas_em_laboratorios_clinicos_ou_de_patologia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 179,
                        "recurring_price": 0,
                        "label": "Falha ou ausência de manutenção preventiva/corretiva",
                        "value": "falha_ou_ausencia_de_manutencao_preventiva_corretiva",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 180,
                        "recurring_price": 0,
                        "label": "Falha protocolo de tromboembolismo venoso (tev)",
                        "value": "falha_protocolo_de_tromboembolismo_venoso_tev",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 181,
                        "recurring_price": 0,
                        "label": "Falha relacionada a estrutura física",
                        "value": "falha_relacionada_a_estrutura_fisica",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 182,
                        "recurring_price": 0,
                        "label": "Falha relacionada a hemotransfusão",
                        "value": "falha_relacionada_a_hemotransfusao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 183,
                        "recurring_price": 0,
                        "label": "Falha relacionada a materiais",
                        "value": "falha_relacionada_a_materiais",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 184,
                        "recurring_price": 0,
                        "label": "Falha relacionada a recursos organizacionais",
                        "value": "falha_relacionada_a_recursos_organizacionais",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 185,
                        "recurring_price": 0,
                        "label": "Falta de amenities (sabonete, shampoo e outros)",
                        "value": "falta_de_amenities_sabonete_shampoo_e_outros",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 186,
                        "recurring_price": 0,
                        "label": "Falta de enxoval",
                        "value": "falta_de_enxoval",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 187,
                        "recurring_price": 0,
                        "label": "Falta de material/medicamento/OPME",
                        "value": "falta_de_material_medicamento_opme",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 188,
                        "recurring_price": 0,
                        "label": "Falta de uniforme",
                        "value": "falta_de_uniforme",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 189,
                        "recurring_price": 0,
                        "label": "Flebite",
                        "value": "flebite",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 190,
                        "recurring_price": 0,
                        "label": "Flebite (química ou mecânica)",
                        "value": "flebite_quimica_ou_mecanica",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 191,
                        "recurring_price": 0,
                        "label": "Força contundente (esmagamento, fricção e conflito)",
                        "value": "forca_contundente_esmagamento_fricção_e_conflito",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 192,
                        "recurring_price": 0,
                        "label": "Força mecânica (onda de choque ou contato de equipamento)",
                        "value": "forca_mecanica_onda_de_choque_ou_contato_de_equipamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 193,
                        "recurring_price": 0,
                        "label": "Força perfurante (corte, mordedura, inoculação de veneno, ferroada, picada)",
                        "value": "forca_perfurante_corte_mordedura_inoculacao_de_veneno_ferroada_picada",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 194,
                        "recurring_price": 0,
                        "label": "Gastrostomia",
                        "value": "gastrostomia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 195,
                        "recurring_price": 0,
                        "label": "Hematoma",
                        "value": "hematoma",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 196,
                        "recurring_price": 0,
                        "label": "Hemorragia após cirurgia",
                        "value": "hemorragia_apos_cirurgia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 197,
                        "recurring_price": 0,
                        "label": "Ilegibilidade/rasura",
                        "value": "ilegibilidade_rasura",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 198,
                        "recurring_price": 0,
                        "label": "Ileostomia",
                        "value": "ileostomia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 199,
                        "recurring_price": 0,
                        "label": "Inapropriado/danificado para a função",
                        "value": "inapropriado_danificado_para_a_funcao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 200,
                        "recurring_price": 0,
                        "label": "Infecção cruzada covid-19",
                        "value": "infeccao_cruzada_covid_19",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 201,
                        "recurring_price": 0,
                        "label": "Infecção relacionada a assistência à saúde",
                        "value": "infeccao_relacionada_a_assistencia_a_saude",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 202,
                        "recurring_price": 0,
                        "label": "Infiltração",
                        "value": "infiltracao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 203,
                        "recurring_price": 0,
                        "label": "Infusão/administração de dieta vencida",
                        "value": "infusao_administracao_de_dieta_vencida",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 204,
                        "recurring_price": 0,
                        "label": "Jejunostomia",
                        "value": "jejunostomia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 205,
                        "recurring_price": 0,
                        "label": "Laudo inadequado",
                        "value": "laudo_inadequado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 206,
                        "recurring_price": 0,
                        "label": "Lentidão do sistema",
                        "value": "lentidao_do_sistema",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 207,
                        "recurring_price": 0,
                        "label": "Lesão de orgão durante cirurgia",
                        "value": "lesao_de_orgao_durante_cirurgia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 208,
                        "recurring_price": 0,
                        "label": "Lesão periestomal (por gastrostomia/bolsa de colostomia e outros)",
                        "value": "lesao_periestomal_por_gastrostomia_bolsa_de_colostomia_e_outros",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 209,
                        "recurring_price": 0,
                        "label": "Lesão por pressão",
                        "value": "lesao_por_pressao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 210,
                        "recurring_price": 0,
                        "label": "Lesão por pressão adquirida no hospital",
                        "value": "lesao_por_pressao_adquirida_no_hospital",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 211,
                        "recurring_price": 0,
                        "label": "lesão por pressão relacionada a dispositivo médico",
                        "value": "lesao_por_pressao_relacionada_a_dispositivo_medico",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 212,
                        "recurring_price": 0,
                        "label": "Lesão presente na admissão do paciente no hospital (proveniente da residência ou outros)",
                        "value": "lesao_presente_na_admissao_do_paciente_no_hospital_proveniente_da_residencia_ou_outros",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 213,
                        "recurring_price": 0,
                        "label": "Lixeiras com sacos incorretos",
                        "value": "lixeiras_com_sacos_incorretos",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 214,
                        "recurring_price": 0,
                        "label": "Material/instrumental danificado",
                        "value": "material_instrumental_danificado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 215,
                        "recurring_price": 0,
                        "label": "Material/instrumental extraviado",
                        "value": "material_instrumental_extraviado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 216,
                        "recurring_price": 0,
                        "label": "Material/medicamento/OPME vencido/violado/danificado",
                        "value": "material_medicamento_opme_vencido_violado_danificado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 217,
                        "recurring_price": 0,
                        "label": "Material vencido ou violado",
                        "value": "material_vencido_ou_violado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 218,
                        "recurring_price": 0,
                        "label": "Mecanismo de lesão (exposição a baixa pressão)",
                        "value": "mecanismo_de_lesao_exposicao_a_baixa_pressao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 219,
                        "recurring_price": 0,
                        "label": "Mecanismo de lesão (exposição a eletricidade/radiação)",
                        "value": "mecanismo_de_lesao_exposicao_a_eletricidade_radiacao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 220,
                        "recurring_price": 0,
                        "label": "Mecanismo de lesão (exposição a pressão do ar)",
                        "value": "mecanismo_de_lesao_exposicao_a_pressao_do_ar",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 221,
                        "recurring_price": 0,
                        "label": "Mecanismo de lesão (exposição a ruídos/vibrações)",
                        "value": "mecanismo_de_lesao_exposicao_a_ruidos_vibracoes",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 222,
                        "recurring_price": 0,
                        "label": "Mecanismo térmico (sobreaquecimento ou frio excessivo)",
                        "value": "mecanismo_termico_sobreaquecimento_ou_frio_excessivo",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 223,
                        "recurring_price": 0,
                        "label": "Não administração do medicamento prescrito",
                        "value": "nao_administracao_do_medicamento_prescrito",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 224,
                        "recurring_price": 0,
                        "label": "Não realização da coleta de exames solicitado",
                        "value": "nao_realizacao_da_coleta_de_exames_solicitado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 225,
                        "recurring_price": 0,
                        "label": "Não sinalização de resultados críticos",
                        "value": "nao_sinalizacao_de_resultados_criticos",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 226,
                        "recurring_price": 0,
                        "label": "Nefrostomia",
                        "value": "nefrostomia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 227,
                        "recurring_price": 0,
                        "label": "Objeto esquecido em cavidade após cirurgia",
                        "value": "objeto_esquecido_em_cavidade_apos_cirurgia",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 228,
                        "recurring_price": 0,
                        "label": "Ofensa verbal",
                        "value": "ofensa_verbal",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 229,
                        "recurring_price": 0,
                        "label": "Outras lesões (especificar)",
                        "value": "outras_lesoes_especificar",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 230,
                        "recurring_price": 0,
                        "label": "Outro",
                        "value": "outro",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 231,
                        "recurring_price": 0,
                        "label": "Outros (especificar problema e sistema)",
                        "value": "outros_especificar_problema_e_sistema",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 232,
                        "recurring_price": 0,
                        "label": "Perda de amostras para exames",
                        "value": "perda_de_amostras_para_exames",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 233,
                        "recurring_price": 0,
                        "label": "Perda de eficácia terapêutica do medicamento",
                        "value": "perda_de_eficacia_terapeutica_do_medicamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 234,
                        "recurring_price": 0,
                        "label": "Pneumotórax",
                        "value": "pneumotorax",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 235,
                        "recurring_price": 0,
                        "label": "Predial danificado",
                        "value": "predial_danificado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 236,
                        "recurring_price": 0,
                        "label": "Predial deteriorado",
                        "value": "predial_deteriorado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 237,
                        "recurring_price": 0,
                        "label": "Predial inadequado (ex: banheiro para cadeirante inadequado)",
                        "value": "predial_inadequado_ex__banheiro_para_cadeirante_inadequado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 238,
                        "recurring_price": 0,
                        "label": "Predial inexistente (estrutura física)",
                        "value": "predial_inexistente_estrutura_fisica",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 239,
                        "recurring_price": 0,
                        "label": "Presença de material/instrumental no enxoval",
                        "value": "presenca_de_material_instrumental_no_enxoval",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 240,
                        "recurring_price": 0,
                        "label": "Presença de peca anatômica no enxoval",
                        "value": "presenca_de_peca_anatomica_no_enxoval",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 241,
                        "recurring_price": 0,
                        "label": "Presença de perfurocortante no enxoval",
                        "value": "presenca_de_perfurocortante_no_enxoval",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 242,
                        "recurring_price": 0,
                        "label": "Presença de vetores",
                        "value": "presenca_de_vetores",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 243,
                        "recurring_price": 0,
                        "label": "Problemas com uso/abuso de substâncias",
                        "value": "problemas_com_uso_abuso_de_substancias",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 244,
                        "recurring_price": 0,
                        "label": "Procedimento clínico não realizado",
                        "value": "procedimento_clinico_nao_realizado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 245,
                        "recurring_price": 0,
                        "label": "Procedimento realizado incorretamente",
                        "value": "procedimento_realizado_incorretamente",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 246,
                        "recurring_price": 0,
                        "label": "Quase queda do paciente",
                        "value": "quase_queda_do_paciente",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 247,
                        "recurring_price": 0,
                        "label": "Queda do paciente",
                        "value": "queda_do_paciente",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 248,
                        "recurring_price": 0,
                        "label": "Queimadura",
                        "value": "queimadura",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 249,
                        "recurring_price": 0,
                        "label": "Queimadura de paciente",
                        "value": "queimadura_de_paciente",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 250,
                        "recurring_price": 0,
                        "label": "Queimadura por placa de bisturi",
                        "value": "queimadura_por_placa_de_bisturi",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 251,
                        "recurring_price": 0,
                        "label": "Reabordagem cirúrgica",
                        "value": "reabordagem_cirurgica",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 252,
                        "recurring_price": 0,
                        "label": "Reabordagem cirúrgica não programada",
                        "value": "reabordagem_cirurgica_nao_programada",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 253,
                        "recurring_price": 0,
                        "label": "Reação adversa ao medicamento",
                        "value": "reacao_adversa_ao_medicamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 254,
                        "recurring_price": 0,
                        "label": "Reação alérgica",
                        "value": "reacao_alergica",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 255,
                        "recurring_price": 0,
                        "label": "Reação transfusional",
                        "value": "reacao_transfusional",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 256,
                        "recurring_price": 0,
                        "label": "Skin tears",
                        "value": "skin_tears",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 257,
                        "recurring_price": 0,
                        "label": "Solicitação de novo envio de medicamento",
                        "value": "solicitacao_de_novo_envio_de_medicamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 258,
                        "recurring_price": 0,
                        "label": "Suspeita de medicamento falsificado",
                        "value": "suspeita_de_medicamento_falsificado",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 259,
                        "recurring_price": 0,
                        "label": "Transmissão cruzada covid-19",
                        "value": "transmissao_cruzada_covid_19",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 260,
                        "recurring_price": 0,
                        "label": "Troca de exames",
                        "value": "troca_de_exames",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 261,
                        "recurring_price": 0,
                        "label": "Troca de hemocomponentes",
                        "value": "troca_de_hemocomponentes",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 262,
                        "recurring_price": 0,
                        "label": "Troca/falha na identificação do frasco",
                        "value": "troca_falha_na_identificacao_do_frasco",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 263,
                        "recurring_price": 0,
                        "label": "Tromboembolismo venoso (TEV)",
                        "value": "tromboembolismo_venoso_tev",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 264,
                        "recurring_price": 0,
                        "label": "Uso inadequado do enxoval",
                        "value": "uso_inadequado_do_enxoval",
                        "price_currency": ""
                      }
                    ],
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 4400
                  },
                  {
                    "active": true,
                    "label": "Observação da classificação da notificação",
                    "dynamic_value_field": "",
                    "type": 2,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "multi_line_text",
                    "display_type": "Texto de Várias Linhas",
                    "render_label": true,
                    "read_only": false,
                    "name": "u_observation_incident_classification",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "c81378dbdb4035108394816404961938",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 4500
                  },
                  {
                    "active": true,
                    "label": "Classificação OMS",
                    "dynamic_value_field": "",
                    "type": 5,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "select_box",
                    "display_type": "Selecionar Caixa",
                    "render_label": true,
                    "read_only": false,
                    "name": "u_oms_classification",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "cb10f8d7db403510839481640496195b",
                    "choices": [
                      {
                        "index": 0,
                        "label": "-- Nenhum --",
                        "value": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 1,
                        "recurring_price": 0,
                        "label": "Administração Clínica",
                        "value": "administracao_clinica",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 2,
                        "recurring_price": 0,
                        "label": "Procedimento/Processo Clínico",
                        "value": "procedimento_processo_clinico",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 3,
                        "recurring_price": 0,
                        "label": "Infecção relacionado à assistência a saúde",
                        "value": "infeccao_rel_a_assistencia_a_saude",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 4,
                        "recurring_price": 0,
                        "label": "Gerenciamento de recursos/organizacional",
                        "value": "gerenciamento_de_recursos_organizacional",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 5,
                        "recurring_price": 0,
                        "label": "Medicamentos/Fluidos EV",
                        "value": "medicamentos_fluidos_ev",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 6,
                        "recurring_price": 0,
                        "label": "Nutrição",
                        "value": "nutricao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 7,
                        "recurring_price": 0,
                        "label": "Hemoderivados",
                        "value": "hemoderivados",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 8,
                        "recurring_price": 0,
                        "label": "Acidente com o paciente",
                        "value": "acidente_com_o_paciente",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 9,
                        "recurring_price": 0,
                        "label": "Comportamento",
                        "value": "comportamento",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 10,
                        "recurring_price": 0,
                        "label": "Equipamentos",
                        "value": "equipamentos",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 11,
                        "recurring_price": 0,
                        "label": "Estrutura",
                        "value": "estrutura",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 12,
                        "recurring_price": 0,
                        "label": "Documentação",
                        "value": "documentacao",
                        "price_currency": ""
                      },
                      {
                        "recurring_price_currency": "",
                        "price": 0,
                        "index": 13,
                        "recurring_price": 0,
                        "label": "Gases/Oxigênio",
                        "value": "gases_oxigenio",
                        "price_currency": ""
                      }
                    ],
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 4600
                  },
                  {
                    "active": true,
                    "label": "Data e hora da finalização do Gestor",
                    "dynamic_value_field": "",
                    "type": 10,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "date_time",
                    "display_type": "Data/Hora",
                    "render_label": true,
                    "read_only": false,
                    "name": "u_date_and_time_closed_by_manager",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "2e9fa957dbc435108394816404961918",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "t_value": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 4800
                  },
                  {
                    "active": true,
                    "label": "Data e hora notificação finalizada",
                    "dynamic_value_field": "",
                    "type": 10,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "date_time",
                    "display_type": "Data/Hora",
                    "render_label": true,
                    "read_only": false,
                    "name": "u_date_and_hour_notification_closed",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "ddb0bd9bdbc43510839481640496191d",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "t_value": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 5000
                  },
                  {
                    "active": true,
                    "label": "Tratado por",
                    "dynamic_value_field": "",
                    "type": 8,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "reference",
                    "display_type": "Referência",
                    "reference": "x_rdsls_notificabe_notifica_users",
                    "render_label": true,
                    "ref_qualifier": "",
                    "read_only": false,
                    "name": "u_treatment_by",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "e1df2997dbc435108394816404961908",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 5200
                  },
                  {
                    "active": true,
                    "label": "Observação notificação externa",
                    "dynamic_value_field": "",
                    "type": 6,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "single_line_text",
                    "display_type": "Texto de Linha Única",
                    "render_label": true,
                    "read_only": false,
                    "name": "u_note_external_notification",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "af7eb15bdb083510839481640496192d",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 5400
                  },
                  {
                    "active": true,
                    "label": "Protocolo Certificadora/Acreditadora",
                    "dynamic_value_field": "",
                    "type": 6,
                    "mandatory": false,
                    "displayvalue": "",
                    "friendly_type": "single_line_text",
                    "display_type": "Texto de Linha Única",
                    "render_label": true,
                    "read_only": false,
                    "name": "u_certifier_accreditor_protocol",
                    "attributes": "edge_encryption_enabled=true",
                    "id": "fc4ebd1bdb0835108394816404961902",
                    "value": "",
                    "dynamic_value_dot_walk_path": "",
                    "help_text": "",
                    "max_length": 0,
                    "order": 5600
                  }
                ],
                "hasSplit": false,
                "containerEndId": null,
                "id": "f074827f1bd1251060d9426fe54bcb9d",
                "value": null,
                "dynamic_value_dot_walk_path": "",
                "max_length": 0,
                "order": 2300,
                "containerType": "container",
                "active": false,
                "label": "Sobre o paciente",
                "dynamic_value_field": "",
                "columnCount": 1,
                "displayvalue": "",
                "layout": "normal",
                "render_label": false,
                "name": "sobre_o_paciente",
                "attributes": "edge_encryption_enabled=true",
                "help_text": ""
              }
            ]
          }
    }
]